var ei = function() {
  return !1;
};
const ii = ei;
var oi = function() {
  return !0;
};
const ui = oi, ai = {
  "@@functional/placeholder": !0
};
function m(r) {
  return r != null && typeof r == "object" && r["@@functional/placeholder"] === !0;
}
function p(r) {
  return function t(n) {
    return arguments.length === 0 || m(n) ? t : r.apply(this, arguments);
  };
}
function s(r) {
  return function t(n, e) {
    switch (arguments.length) {
      case 0:
        return t;
      case 1:
        return m(n) ? t : p(function(i) {
          return r(n, i);
        });
      default:
        return m(n) && m(e) ? t : m(n) ? p(function(i) {
          return r(i, e);
        }) : m(e) ? p(function(i) {
          return r(n, i);
        }) : r(n, e);
    }
  };
}
var si = /* @__PURE__ */ s(function(t, n) {
  return Number(t) + Number(n);
});
const kt = si;
function D(r, t) {
  r = r || [], t = t || [];
  var n, e = r.length, i = t.length, o = [];
  for (n = 0; n < e; )
    o[o.length] = r[n], n += 1;
  for (n = 0; n < i; )
    o[o.length] = t[n], n += 1;
  return o;
}
function R(r, t) {
  switch (r) {
    case 0:
      return function() {
        return t.apply(this, arguments);
      };
    case 1:
      return function(n) {
        return t.apply(this, arguments);
      };
    case 2:
      return function(n, e) {
        return t.apply(this, arguments);
      };
    case 3:
      return function(n, e, i) {
        return t.apply(this, arguments);
      };
    case 4:
      return function(n, e, i, o) {
        return t.apply(this, arguments);
      };
    case 5:
      return function(n, e, i, o, u) {
        return t.apply(this, arguments);
      };
    case 6:
      return function(n, e, i, o, u, a) {
        return t.apply(this, arguments);
      };
    case 7:
      return function(n, e, i, o, u, a, c) {
        return t.apply(this, arguments);
      };
    case 8:
      return function(n, e, i, o, u, a, c, f) {
        return t.apply(this, arguments);
      };
    case 9:
      return function(n, e, i, o, u, a, c, f, l) {
        return t.apply(this, arguments);
      };
    case 10:
      return function(n, e, i, o, u, a, c, f, l, d) {
        return t.apply(this, arguments);
      };
    default:
      throw new Error("First argument to _arity must be a non-negative integer no greater than ten");
  }
}
function H(r, t, n) {
  return function() {
    for (var e = [], i = 0, o = r, u = 0; u < t.length || i < arguments.length; ) {
      var a;
      u < t.length && (!m(t[u]) || i >= arguments.length) ? a = t[u] : (a = arguments[i], i += 1), e[u] = a, m(a) || (o -= 1), u += 1;
    }
    return o <= 0 ? n.apply(this, e) : R(o, H(r, e, n));
  };
}
var _ = /* @__PURE__ */ s(function(t, n) {
  return t === 1 ? p(n) : R(t, H(t, [], n));
}), ci = /* @__PURE__ */ p(function(t) {
  return _(t.length, function() {
    var n = 0, e = arguments[0], i = arguments[arguments.length - 1], o = Array.prototype.slice.call(arguments, 0);
    return o[0] = function() {
      var u = e.apply(this, D(arguments, [n, i]));
      return n += 1, u;
    }, t.apply(this, o);
  });
});
const fi = ci;
function h(r) {
  return function t(n, e, i) {
    switch (arguments.length) {
      case 0:
        return t;
      case 1:
        return m(n) ? t : s(function(o, u) {
          return r(n, o, u);
        });
      case 2:
        return m(n) && m(e) ? t : m(n) ? s(function(o, u) {
          return r(o, e, u);
        }) : m(e) ? s(function(o, u) {
          return r(n, o, u);
        }) : p(function(o) {
          return r(n, e, o);
        });
      default:
        return m(n) && m(e) && m(i) ? t : m(n) && m(e) ? s(function(o, u) {
          return r(o, u, i);
        }) : m(n) && m(i) ? s(function(o, u) {
          return r(o, e, u);
        }) : m(e) && m(i) ? s(function(o, u) {
          return r(n, o, u);
        }) : m(n) ? p(function(o) {
          return r(o, e, i);
        }) : m(e) ? p(function(o) {
          return r(n, o, i);
        }) : m(i) ? p(function(o) {
          return r(n, e, o);
        }) : r(n, e, i);
    }
  };
}
var li = /* @__PURE__ */ h(function(t, n, e) {
  var i = e.length;
  if (t >= i || t < -i)
    return e;
  var o = (i + t) % i, u = D(e);
  return u[o] = n(e[o]), u;
});
const yr = li, I = Array.isArray || function(t) {
  return t != null && t.length >= 0 && Object.prototype.toString.call(t) === "[object Array]";
};
function wn(r) {
  return r != null && typeof r["@@transducer/step"] == "function";
}
function w(r, t, n) {
  return function() {
    if (arguments.length === 0)
      return n();
    var e = arguments[arguments.length - 1];
    if (!I(e)) {
      for (var i = 0; i < r.length; ) {
        if (typeof e[r[i]] == "function")
          return e[r[i]].apply(e, Array.prototype.slice.call(arguments, 0, -1));
        i += 1;
      }
      if (wn(e)) {
        var o = t.apply(null, Array.prototype.slice.call(arguments, 0, -1));
        return o(e);
      }
    }
    return n.apply(this, arguments);
  };
}
function M(r) {
  return r && r["@@transducer/reduced"] ? r : {
    "@@transducer/value": r,
    "@@transducer/reduced": !0
  };
}
const y = {
  init: function() {
    return this.xf["@@transducer/init"]();
  },
  result: function(r) {
    return this.xf["@@transducer/result"](r);
  }
};
var pi = /* @__PURE__ */ function() {
  function r(t, n) {
    this.xf = n, this.f = t, this.all = !0;
  }
  return r.prototype["@@transducer/init"] = y.init, r.prototype["@@transducer/result"] = function(t) {
    return this.all && (t = this.xf["@@transducer/step"](t, !0)), this.xf["@@transducer/result"](t);
  }, r.prototype["@@transducer/step"] = function(t, n) {
    return this.f(n) || (this.all = !1, t = M(this.xf["@@transducer/step"](t, !1))), t;
  }, r;
}(), hi = /* @__PURE__ */ s(function(t, n) {
  return new pi(t, n);
}), di = /* @__PURE__ */ s(
  /* @__PURE__ */ w(["all"], hi, function(t, n) {
    for (var e = 0; e < n.length; ) {
      if (!t(n[e]))
        return !1;
      e += 1;
    }
    return !0;
  })
);
const gr = di;
var vi = /* @__PURE__ */ s(function(t, n) {
  return n > t ? n : t;
});
const at = vi;
function G(r, t) {
  for (var n = 0, e = t.length, i = Array(e); n < e; )
    i[n] = r(t[n]), n += 1;
  return i;
}
function nt(r) {
  return Object.prototype.toString.call(r) === "[object String]";
}
var At = /* @__PURE__ */ p(function(t) {
  return I(t) ? !0 : !t || typeof t != "object" || nt(t) ? !1 : t.length === 0 ? !0 : t.length > 0 ? t.hasOwnProperty(0) && t.hasOwnProperty(t.length - 1) : !1;
}), yi = /* @__PURE__ */ function() {
  function r(t) {
    this.f = t;
  }
  return r.prototype["@@transducer/init"] = function() {
    throw new Error("init not implemented on XWrap");
  }, r.prototype["@@transducer/result"] = function(t) {
    return t;
  }, r.prototype["@@transducer/step"] = function(t, n) {
    return this.f(t, n);
  }, r;
}();
function mr(r) {
  return new yi(r);
}
var wr = /* @__PURE__ */ s(function(t, n) {
  return R(t.length, function() {
    return t.apply(n, arguments);
  });
});
function gi(r, t, n) {
  for (var e = 0, i = n.length; e < i; ) {
    if (t = r["@@transducer/step"](t, n[e]), t && t["@@transducer/reduced"]) {
      t = t["@@transducer/value"];
      break;
    }
    e += 1;
  }
  return r["@@transducer/result"](t);
}
function Hn(r, t, n) {
  for (var e = n.next(); !e.done; ) {
    if (t = r["@@transducer/step"](t, e.value), t && t["@@transducer/reduced"]) {
      t = t["@@transducer/value"];
      break;
    }
    e = n.next();
  }
  return r["@@transducer/result"](t);
}
function Zn(r, t, n, e) {
  return r["@@transducer/result"](n[e](wr(r["@@transducer/step"], r), t));
}
var Qn = typeof Symbol < "u" ? Symbol.iterator : "@@iterator";
function A(r, t, n) {
  if (typeof r == "function" && (r = mr(r)), At(n))
    return gi(r, t, n);
  if (typeof n["fantasy-land/reduce"] == "function")
    return Zn(r, t, n, "fantasy-land/reduce");
  if (n[Qn] != null)
    return Hn(r, t, n[Qn]());
  if (typeof n.next == "function")
    return Hn(r, t, n);
  if (typeof n.reduce == "function")
    return Zn(r, t, n, "reduce");
  throw new TypeError("reduce: list must be array or iterable");
}
var mi = /* @__PURE__ */ function() {
  function r(t, n) {
    this.xf = n, this.f = t;
  }
  return r.prototype["@@transducer/init"] = y.init, r.prototype["@@transducer/result"] = y.result, r.prototype["@@transducer/step"] = function(t, n) {
    return this.xf["@@transducer/step"](t, this.f(n));
  }, r;
}(), wi = /* @__PURE__ */ s(function(t, n) {
  return new mi(t, n);
});
function $(r, t) {
  return Object.prototype.hasOwnProperty.call(t, r);
}
var tr = Object.prototype.toString, $r = /* @__PURE__ */ function() {
  return tr.call(arguments) === "[object Arguments]" ? function(t) {
    return tr.call(t) === "[object Arguments]";
  } : function(t) {
    return $("callee", t);
  };
}(), $i = !/* @__PURE__ */ {
  toString: null
}.propertyIsEnumerable("toString"), nr = ["constructor", "valueOf", "isPrototypeOf", "toString", "propertyIsEnumerable", "hasOwnProperty", "toLocaleString"], rr = /* @__PURE__ */ function() {
  return arguments.propertyIsEnumerable("length");
}(), Oi = function(t, n) {
  for (var e = 0; e < t.length; ) {
    if (t[e] === n)
      return !0;
    e += 1;
  }
  return !1;
}, _i = /* @__PURE__ */ p(typeof Object.keys == "function" && !rr ? function(t) {
  return Object(t) !== t ? [] : Object.keys(t);
} : function(t) {
  if (Object(t) !== t)
    return [];
  var n, e, i = [], o = rr && $r(t);
  for (n in t)
    $(n, t) && (!o || n !== "length") && (i[i.length] = n);
  if ($i)
    for (e = nr.length - 1; e >= 0; )
      n = nr[e], $(n, t) && !Oi(i, n) && (i[i.length] = n), e -= 1;
  return i;
});
const j = _i;
var S = /* @__PURE__ */ s(
  /* @__PURE__ */ w(["fantasy-land/map", "map"], wi, function(t, n) {
    switch (Object.prototype.toString.call(n)) {
      case "[object Function]":
        return _(n.length, function() {
          return t.call(this, n.apply(this, arguments));
        });
      case "[object Object]":
        return A(function(e, i) {
          return e[i] = t(n[i]), e;
        }, {}, j(n));
      default:
        return G(t, n);
    }
  })
);
const T = Number.isInteger || function(t) {
  return t << 0 === t;
};
var Z = /* @__PURE__ */ s(function(t, n) {
  var e = t < 0 ? n.length + t : t;
  return nt(n) ? n.charAt(e) : n[e];
}), Ai = /* @__PURE__ */ s(function(t, n) {
  if (n != null)
    return T(t) ? Z(t, n) : n[t];
});
const q = Ai;
var xi = /* @__PURE__ */ s(function(t, n) {
  return S(q(t), n);
});
const st = xi;
var Ii = /* @__PURE__ */ h(A);
const L = Ii;
var Si = /* @__PURE__ */ p(function(t) {
  return _(L(at, 0, st("length", t)), function() {
    for (var n = 0, e = t.length; n < e; ) {
      if (!t[n].apply(this, arguments))
        return !1;
      n += 1;
    }
    return !0;
  });
});
const bi = Si;
var Ei = /* @__PURE__ */ p(function(t) {
  return function() {
    return t;
  };
});
const Mt = Ei;
var Or = /* @__PURE__ */ s(function(t, n) {
  return t && n;
}), ji = /* @__PURE__ */ function() {
  function r(t, n) {
    this.xf = n, this.f = t, this.any = !1;
  }
  return r.prototype["@@transducer/init"] = y.init, r.prototype["@@transducer/result"] = function(t) {
    return this.any || (t = this.xf["@@transducer/step"](t, !1)), this.xf["@@transducer/result"](t);
  }, r.prototype["@@transducer/step"] = function(t, n) {
    return this.f(n) && (this.any = !0, t = M(this.xf["@@transducer/step"](t, !0))), t;
  }, r;
}(), Wi = /* @__PURE__ */ s(function(t, n) {
  return new ji(t, n);
}), Bi = /* @__PURE__ */ s(
  /* @__PURE__ */ w(["any"], Wi, function(t, n) {
    for (var e = 0; e < n.length; ) {
      if (t(n[e]))
        return !0;
      e += 1;
    }
    return !1;
  })
);
const _r = Bi;
var Di = /* @__PURE__ */ p(function(t) {
  return _(L(at, 0, st("length", t)), function() {
    for (var n = 0, e = t.length; n < e; ) {
      if (t[n].apply(this, arguments))
        return !0;
      n += 1;
    }
    return !1;
  });
});
const Pi = Di;
var $n = /* @__PURE__ */ s(function(t, n) {
  return typeof n["fantasy-land/ap"] == "function" ? n["fantasy-land/ap"](t) : typeof t.ap == "function" ? t.ap(n) : typeof t == "function" ? function(e) {
    return t(e)(n(e));
  } : A(function(e, i) {
    return D(e, S(i, n));
  }, [], t);
});
function Ci(r, t) {
  for (var n = 0, e = t.length - (r - 1), i = new Array(e >= 0 ? e : 0); n < e; )
    i[n] = Array.prototype.slice.call(t, n, n + r), n += 1;
  return i;
}
var Ri = /* @__PURE__ */ function() {
  function r(t, n) {
    this.xf = n, this.pos = 0, this.full = !1, this.acc = new Array(t);
  }
  return r.prototype["@@transducer/init"] = y.init, r.prototype["@@transducer/result"] = function(t) {
    return this.acc = null, this.xf["@@transducer/result"](t);
  }, r.prototype["@@transducer/step"] = function(t, n) {
    return this.store(n), this.full ? this.xf["@@transducer/step"](t, this.getCopy()) : t;
  }, r.prototype.store = function(t) {
    this.acc[this.pos] = t, this.pos += 1, this.pos === this.acc.length && (this.pos = 0, this.full = !0);
  }, r.prototype.getCopy = function() {
    return D(Array.prototype.slice.call(this.acc, this.pos), Array.prototype.slice.call(this.acc, 0, this.pos));
  }, r;
}(), Li = /* @__PURE__ */ s(function(t, n) {
  return new Ri(t, n);
}), Ni = /* @__PURE__ */ s(
  /* @__PURE__ */ w([], Li, Ci)
);
const Ti = Ni;
var ki = /* @__PURE__ */ s(function(t, n) {
  return D(n, [t]);
});
const Mi = ki;
var qi = /* @__PURE__ */ s(function(t, n) {
  return t.apply(this, n);
});
const Ar = qi;
var Ui = /* @__PURE__ */ p(function(t) {
  for (var n = j(t), e = n.length, i = [], o = 0; o < e; )
    i[o] = t[n[o]], o += 1;
  return i;
});
const xr = Ui;
function er(r, t) {
  return I(t) ? t.map(r) : j(t).reduce(function(n, e) {
    return n[e] = r(t[e]), n;
  }, {});
}
var Fi = /* @__PURE__ */ p(function r(t) {
  return t = er(function(n) {
    return typeof n == "function" ? n : r(n);
  }, t), _(L(at, 0, st("length", xr(t))), function() {
    var n = arguments;
    return er(function(e) {
      return Ar(e, n);
    }, t);
  });
});
const Xi = Fi;
var Ki = /* @__PURE__ */ s(function(t, n) {
  return n(t);
});
const zi = Ki;
var Gi = /* @__PURE__ */ h(function(t, n, e) {
  var i = t(n), o = t(e);
  return i < o ? -1 : i > o ? 1 : 0;
});
const Vi = Gi;
function On(r, t, n) {
  if (T(r) && I(n)) {
    var e = [].concat(n);
    return e[r] = t, e;
  }
  var i = {};
  for (var o in n)
    i[o] = n[o];
  return i[r] = t, i;
}
var Yi = /* @__PURE__ */ p(function(t) {
  return t == null;
});
const wt = Yi;
var Ji = /* @__PURE__ */ h(function r(t, n, e) {
  if (t.length === 0)
    return n;
  var i = t[0];
  if (t.length > 1) {
    var o = !wt(e) && $(i, e) ? e[i] : T(t[1]) ? [] : {};
    n = r(Array.prototype.slice.call(t, 1), n, o);
  }
  return On(i, n, e);
});
const xt = Ji;
var Hi = /* @__PURE__ */ h(function(t, n, e) {
  return xt([t], n, e);
});
const It = Hi;
var Zi = /* @__PURE__ */ s(function(t, n) {
  switch (t) {
    case 0:
      return function() {
        return n.call(this);
      };
    case 1:
      return function(e) {
        return n.call(this, e);
      };
    case 2:
      return function(e, i) {
        return n.call(this, e, i);
      };
    case 3:
      return function(e, i, o) {
        return n.call(this, e, i, o);
      };
    case 4:
      return function(e, i, o, u) {
        return n.call(this, e, i, o, u);
      };
    case 5:
      return function(e, i, o, u, a) {
        return n.call(this, e, i, o, u, a);
      };
    case 6:
      return function(e, i, o, u, a, c) {
        return n.call(this, e, i, o, u, a, c);
      };
    case 7:
      return function(e, i, o, u, a, c, f) {
        return n.call(this, e, i, o, u, a, c, f);
      };
    case 8:
      return function(e, i, o, u, a, c, f, l) {
        return n.call(this, e, i, o, u, a, c, f, l);
      };
    case 9:
      return function(e, i, o, u, a, c, f, l, d) {
        return n.call(this, e, i, o, u, a, c, f, l, d);
      };
    case 10:
      return function(e, i, o, u, a, c, f, l, d, g) {
        return n.call(this, e, i, o, u, a, c, f, l, d, g);
      };
    default:
      throw new Error("First argument to nAry must be a non-negative integer no greater than ten");
  }
});
const qt = Zi;
var Qi = /* @__PURE__ */ p(function(t) {
  return qt(2, t);
});
const to = Qi;
function rt(r) {
  var t = Object.prototype.toString.call(r);
  return t === "[object Function]" || t === "[object AsyncFunction]" || t === "[object GeneratorFunction]" || t === "[object AsyncGeneratorFunction]";
}
var Ir = /* @__PURE__ */ s(function(t, n) {
  var e = _(t, n);
  return _(t, function() {
    return A($n, S(e, arguments[0]), Array.prototype.slice.call(arguments, 1));
  });
}), Ut = /* @__PURE__ */ p(function(t) {
  return Ir(t.length, t);
}), no = /* @__PURE__ */ s(function(t, n) {
  return rt(t) ? function() {
    return t.apply(this, arguments) && n.apply(this, arguments);
  } : Ut(Or)(t, n);
});
const _n = no;
var ro = /* @__PURE__ */ p(function(t) {
  return t.apply(this, Array.prototype.slice.call(arguments, 1));
});
const eo = ro;
function Sr(r) {
  return function t(n) {
    for (var e, i, o, u = [], a = 0, c = n.length; a < c; ) {
      if (At(n[a]))
        for (e = r ? t(n[a]) : n[a], o = 0, i = e.length; o < i; )
          u[u.length] = e[o], o += 1;
      else
        u[u.length] = n[a];
      a += 1;
    }
    return u;
  };
}
function io(r) {
  return {
    "@@transducer/value": r,
    "@@transducer/reduced": !0
  };
}
var oo = function(r) {
  return {
    "@@transducer/init": y.init,
    "@@transducer/result": function(t) {
      return r["@@transducer/result"](t);
    },
    "@@transducer/step": function(t, n) {
      var e = r["@@transducer/step"](t, n);
      return e["@@transducer/reduced"] ? io(e) : e;
    }
  };
}, uo = function(t) {
  var n = oo(t);
  return {
    "@@transducer/init": y.init,
    "@@transducer/result": function(e) {
      return n["@@transducer/result"](e);
    },
    "@@transducer/step": function(e, i) {
      return At(i) ? A(n, e, i) : A(n, e, [i]);
    }
  };
}, ao = /* @__PURE__ */ s(function(t, n) {
  return S(t, uo(n));
}), so = /* @__PURE__ */ s(
  /* @__PURE__ */ w(["fantasy-land/chain", "chain"], ao, function(t, n) {
    return typeof n == "function" ? function(e) {
      return t(n(e))(e);
    } : Sr(!1)(S(t, n));
  })
);
const br = so;
var co = /* @__PURE__ */ h(function(t, n, e) {
  if (t > n)
    throw new Error("min must not be greater than max in clamp(min, max, value)");
  return e < t ? t : e > n ? n : e;
});
const fo = co;
function Er(r) {
  return new RegExp(r.source, (r.global ? "g" : "") + (r.ignoreCase ? "i" : "") + (r.multiline ? "m" : "") + (r.sticky ? "y" : "") + (r.unicode ? "u" : ""));
}
var $t = /* @__PURE__ */ p(function(t) {
  return t === null ? "Null" : t === void 0 ? "Undefined" : Object.prototype.toString.call(t).slice(8, -1);
});
function Ft(r, t, n, e) {
  var i = function(u) {
    for (var a = t.length, c = 0; c < a; ) {
      if (r === t[c])
        return n[c];
      c += 1;
    }
    t[c] = r, n[c] = u;
    for (var f in r)
      r.hasOwnProperty(f) && (u[f] = e ? Ft(r[f], t, n, !0) : r[f]);
    return u;
  };
  switch ($t(r)) {
    case "Object":
      return i(Object.create(Object.getPrototypeOf(r)));
    case "Array":
      return i([]);
    case "Date":
      return new Date(r.valueOf());
    case "RegExp":
      return Er(r);
    case "Int8Array":
    case "Uint8Array":
    case "Uint8ClampedArray":
    case "Int16Array":
    case "Uint16Array":
    case "Int32Array":
    case "Uint32Array":
    case "Float32Array":
    case "Float64Array":
    case "BigInt64Array":
    case "BigUint64Array":
      return r.slice();
    default:
      return r;
  }
}
var lo = /* @__PURE__ */ p(function(t) {
  return t != null && typeof t.clone == "function" ? t.clone() : Ft(t, [], [], !0);
});
const po = lo;
var ho = /* @__PURE__ */ s(function(t, n) {
  var e = A(function(u, a) {
    var c = t(a);
    return u[c] === void 0 && (u[c] = []), u[c].push(a), u;
  }, {}, n), i = [];
  for (var o in e)
    i.push(e[o]);
  return i;
});
const vo = ho;
var yo = /* @__PURE__ */ p(function(t) {
  return function(n, e) {
    return t(n, e) ? -1 : t(e, n) ? 1 : 0;
  };
});
const go = yo;
var mo = /* @__PURE__ */ p(function(t) {
  return !t;
});
const An = mo;
var wo = /* @__PURE__ */ Ut(An);
const jr = wo;
function $o(r, t) {
  return function() {
    return t.call(this, r.apply(this, arguments));
  };
}
function St(r, t) {
  return function() {
    var n = arguments.length;
    if (n === 0)
      return t();
    var e = arguments[n - 1];
    return I(e) || typeof e[r] != "function" ? t.apply(this, arguments) : e[r].apply(e, Array.prototype.slice.call(arguments, 0, n - 1));
  };
}
var B = /* @__PURE__ */ h(
  /* @__PURE__ */ St("slice", function(t, n, e) {
    return Array.prototype.slice.call(e, t, n);
  })
), Oo = /* @__PURE__ */ p(
  /* @__PURE__ */ St(
    "tail",
    /* @__PURE__ */ B(1, 1 / 0)
  )
);
const xn = Oo;
function Wr() {
  if (arguments.length === 0)
    throw new Error("pipe requires at least one argument");
  return R(arguments[0].length, L($o, arguments[0], xn(arguments)));
}
var _o = /* @__PURE__ */ p(function(t) {
  return nt(t) ? t.split("").reverse().join("") : Array.prototype.slice.call(t, 0).reverse();
});
const In = _o;
function Sn() {
  if (arguments.length === 0)
    throw new Error("compose requires at least one argument");
  return Wr.apply(this, In(arguments));
}
var Ao = /* @__PURE__ */ Z(0);
const Br = Ao;
function bt(r) {
  return r;
}
var xo = /* @__PURE__ */ p(bt);
const Et = xo;
var Io = /* @__PURE__ */ s(function(t, n) {
  if (n.length <= 0)
    return Et;
  var e = Br(n), i = xn(n);
  return R(e.length, function() {
    return A(function(o, u) {
      return t.call(this, u, o);
    }, e.apply(this, arguments), i);
  });
});
const Dr = Io;
var So = /* @__PURE__ */ s(function(t, n) {
  return Dr.apply(this, [t, In(n)]);
});
const bo = So;
function ir(r) {
  for (var t = [], n; !(n = r.next()).done; )
    t.push(n.value);
  return t;
}
function Y(r, t, n) {
  for (var e = 0, i = n.length; e < i; ) {
    if (r(t, n[e]))
      return !0;
    e += 1;
  }
  return !1;
}
function Eo(r) {
  var t = String(r).match(/^function (\w*)/);
  return t == null ? "" : t[1];
}
function jo(r, t) {
  return r === t ? r !== 0 || 1 / r === 1 / t : r !== r && t !== t;
}
const Ct = typeof Object.is == "function" ? Object.is : jo;
function or(r, t, n, e) {
  var i = ir(r), o = ir(t);
  function u(a, c) {
    return bn(a, c, n.slice(), e.slice());
  }
  return !Y(function(a, c) {
    return !Y(u, c, a);
  }, o, i);
}
function bn(r, t, n, e) {
  if (Ct(r, t))
    return !0;
  var i = $t(r);
  if (i !== $t(t))
    return !1;
  if (typeof r["fantasy-land/equals"] == "function" || typeof t["fantasy-land/equals"] == "function")
    return typeof r["fantasy-land/equals"] == "function" && r["fantasy-land/equals"](t) && typeof t["fantasy-land/equals"] == "function" && t["fantasy-land/equals"](r);
  if (typeof r.equals == "function" || typeof t.equals == "function")
    return typeof r.equals == "function" && r.equals(t) && typeof t.equals == "function" && t.equals(r);
  switch (i) {
    case "Arguments":
    case "Array":
    case "Object":
      if (typeof r.constructor == "function" && Eo(r.constructor) === "Promise")
        return r === t;
      break;
    case "Boolean":
    case "Number":
    case "String":
      if (!(typeof r == typeof t && Ct(r.valueOf(), t.valueOf())))
        return !1;
      break;
    case "Date":
      if (!Ct(r.valueOf(), t.valueOf()))
        return !1;
      break;
    case "Error":
      return r.name === t.name && r.message === t.message;
    case "RegExp":
      if (!(r.source === t.source && r.global === t.global && r.ignoreCase === t.ignoreCase && r.multiline === t.multiline && r.sticky === t.sticky && r.unicode === t.unicode))
        return !1;
      break;
  }
  for (var o = n.length - 1; o >= 0; ) {
    if (n[o] === r)
      return e[o] === t;
    o -= 1;
  }
  switch (i) {
    case "Map":
      return r.size !== t.size ? !1 : or(r.entries(), t.entries(), n.concat([r]), e.concat([t]));
    case "Set":
      return r.size !== t.size ? !1 : or(r.values(), t.values(), n.concat([r]), e.concat([t]));
    case "Arguments":
    case "Array":
    case "Object":
    case "Boolean":
    case "Number":
    case "String":
    case "Date":
    case "Error":
    case "RegExp":
    case "Int8Array":
    case "Uint8Array":
    case "Uint8ClampedArray":
    case "Int16Array":
    case "Uint16Array":
    case "Int32Array":
    case "Uint32Array":
    case "Float32Array":
    case "Float64Array":
    case "ArrayBuffer":
      break;
    default:
      return !1;
  }
  var u = j(r);
  if (u.length !== j(t).length)
    return !1;
  var a = n.concat([r]), c = e.concat([t]);
  for (o = u.length - 1; o >= 0; ) {
    var f = u[o];
    if (!($(f, t) && bn(t[f], r[f], a, c)))
      return !1;
    o -= 1;
  }
  return !0;
}
var W = /* @__PURE__ */ s(function(t, n) {
  return bn(t, n, [], []);
});
function Pr(r, t, n) {
  var e, i;
  if (typeof r.indexOf == "function")
    switch (typeof t) {
      case "number":
        if (t === 0) {
          for (e = 1 / t; n < r.length; ) {
            if (i = r[n], i === 0 && 1 / i === e)
              return n;
            n += 1;
          }
          return -1;
        } else if (t !== t) {
          for (; n < r.length; ) {
            if (i = r[n], typeof i == "number" && i !== i)
              return n;
            n += 1;
          }
          return -1;
        }
        return r.indexOf(t, n);
      case "string":
      case "boolean":
      case "function":
      case "undefined":
        return r.indexOf(t, n);
      case "object":
        if (t === null)
          return r.indexOf(t, n);
    }
  for (; n < r.length; ) {
    if (W(r[n], t))
      return n;
    n += 1;
  }
  return -1;
}
function et(r, t) {
  return Pr(t, r, 0) >= 0;
}
function rn(r) {
  var t = r.replace(/\\/g, "\\\\").replace(/[\b]/g, "\\b").replace(/\f/g, "\\f").replace(/\n/g, "\\n").replace(/\r/g, "\\r").replace(/\t/g, "\\t").replace(/\v/g, "\\v").replace(/\0/g, "\\0");
  return '"' + t.replace(/"/g, '\\"') + '"';
}
var vt = function(t) {
  return (t < 10 ? "0" : "") + t;
}, Wo = typeof Date.prototype.toISOString == "function" ? function(t) {
  return t.toISOString();
} : function(t) {
  return t.getUTCFullYear() + "-" + vt(t.getUTCMonth() + 1) + "-" + vt(t.getUTCDate()) + "T" + vt(t.getUTCHours()) + ":" + vt(t.getUTCMinutes()) + ":" + vt(t.getUTCSeconds()) + "." + (t.getUTCMilliseconds() / 1e3).toFixed(3).slice(2, 5) + "Z";
};
function Cr(r) {
  return function() {
    return !r.apply(this, arguments);
  };
}
function En(r, t) {
  for (var n = 0, e = t.length, i = []; n < e; )
    r(t[n]) && (i[i.length] = t[n]), n += 1;
  return i;
}
function it(r) {
  return Object.prototype.toString.call(r) === "[object Object]";
}
var Bo = /* @__PURE__ */ function() {
  function r(t, n) {
    this.xf = n, this.f = t;
  }
  return r.prototype["@@transducer/init"] = y.init, r.prototype["@@transducer/result"] = y.result, r.prototype["@@transducer/step"] = function(t, n) {
    return this.f(n) ? this.xf["@@transducer/step"](t, n) : t;
  }, r;
}(), Do = /* @__PURE__ */ s(function(t, n) {
  return new Bo(t, n);
}), Po = /* @__PURE__ */ s(
  /* @__PURE__ */ w(["fantasy-land/filter", "filter"], Do, function(r, t) {
    return it(t) ? A(function(n, e) {
      return r(t[e]) && (n[e] = t[e]), n;
    }, {}, j(t)) : (
      // else
      En(r, t)
    );
  })
);
const ct = Po;
var Co = /* @__PURE__ */ s(function(t, n) {
  return ct(Cr(t), n);
});
const ft = Co;
function jn(r, t) {
  var n = function(u) {
    var a = t.concat([r]);
    return et(u, a) ? "<Circular>" : jn(u, a);
  }, e = function(o, u) {
    return G(function(a) {
      return rn(a) + ": " + n(o[a]);
    }, u.slice().sort());
  };
  switch (Object.prototype.toString.call(r)) {
    case "[object Arguments]":
      return "(function() { return arguments; }(" + G(n, r).join(", ") + "))";
    case "[object Array]":
      return "[" + G(n, r).concat(e(r, ft(function(o) {
        return /^\d+$/.test(o);
      }, j(r)))).join(", ") + "]";
    case "[object Boolean]":
      return typeof r == "object" ? "new Boolean(" + n(r.valueOf()) + ")" : r.toString();
    case "[object Date]":
      return "new Date(" + (isNaN(r.valueOf()) ? n(NaN) : rn(Wo(r))) + ")";
    case "[object Null]":
      return "null";
    case "[object Number]":
      return typeof r == "object" ? "new Number(" + n(r.valueOf()) + ")" : 1 / r === -1 / 0 ? "-0" : r.toString(10);
    case "[object String]":
      return typeof r == "object" ? "new String(" + n(r.valueOf()) + ")" : rn(r);
    case "[object Undefined]":
      return "undefined";
    default:
      if (typeof r.toString == "function") {
        var i = r.toString();
        if (i !== "[object Object]")
          return i;
      }
      return "{" + e(r, j(r)).join(", ") + "}";
  }
}
var Ro = /* @__PURE__ */ p(function(t) {
  return jn(t, []);
});
const tt = Ro;
var Lo = /* @__PURE__ */ s(function(t, n) {
  if (I(t)) {
    if (I(n))
      return t.concat(n);
    throw new TypeError(tt(n) + " is not an array");
  }
  if (nt(t)) {
    if (nt(n))
      return t + n;
    throw new TypeError(tt(n) + " is not a string");
  }
  if (t != null && rt(t["fantasy-land/concat"]))
    return t["fantasy-land/concat"](n);
  if (t != null && rt(t.concat))
    return t.concat(n);
  throw new TypeError(tt(t) + ' does not have a method named "concat" or "fantasy-land/concat"');
});
const Wn = Lo;
var No = /* @__PURE__ */ p(function(t) {
  var n = L(at, 0, S(function(e) {
    return e[0].length;
  }, t));
  return R(n, function() {
    for (var e = 0; e < t.length; ) {
      if (t[e][0].apply(this, arguments))
        return t[e][1].apply(this, arguments);
      e += 1;
    }
  });
});
const To = No;
var ko = /* @__PURE__ */ p(function(t) {
  return _(t.length, t);
});
const jt = ko;
var Mo = /* @__PURE__ */ s(function(t, n) {
  if (t > 10)
    throw new Error("Constructor with greater than ten arguments");
  return t === 0 ? function() {
    return new n();
  } : jt(qt(t, function(e, i, o, u, a, c, f, l, d, g) {
    switch (arguments.length) {
      case 1:
        return new n(e);
      case 2:
        return new n(e, i);
      case 3:
        return new n(e, i, o);
      case 4:
        return new n(e, i, o, u);
      case 5:
        return new n(e, i, o, u, a);
      case 6:
        return new n(e, i, o, u, a, c);
      case 7:
        return new n(e, i, o, u, a, c, f);
      case 8:
        return new n(e, i, o, u, a, c, f, l);
      case 9:
        return new n(e, i, o, u, a, c, f, l, d);
      case 10:
        return new n(e, i, o, u, a, c, f, l, d, g);
    }
  }));
});
const Rr = Mo;
var qo = /* @__PURE__ */ p(function(t) {
  return Rr(t.length, t);
});
const Uo = qo;
var Fo = /* @__PURE__ */ s(function(t, n) {
  return _(L(at, 0, st("length", n)), function() {
    var e = arguments, i = this;
    return t.apply(i, G(function(o) {
      return o.apply(i, e);
    }, n));
  });
});
const Lr = Fo;
var Xo = /* @__PURE__ */ jt(function(r, t) {
  return A(function(n, e) {
    return r(e) ? n + 1 : n;
  }, 0, t);
});
const Ko = Xo;
var zo = /* @__PURE__ */ function() {
  function r(t, n, e, i) {
    this.valueFn = t, this.valueAcc = n, this.keyFn = e, this.xf = i, this.inputs = {};
  }
  return r.prototype["@@transducer/init"] = y.init, r.prototype["@@transducer/result"] = function(t) {
    var n;
    for (n in this.inputs)
      if ($(n, this.inputs) && (t = this.xf["@@transducer/step"](t, this.inputs[n]), t["@@transducer/reduced"])) {
        t = t["@@transducer/value"];
        break;
      }
    return this.inputs = null, this.xf["@@transducer/result"](t);
  }, r.prototype["@@transducer/step"] = function(t, n) {
    var e = this.keyFn(n);
    return this.inputs[e] = this.inputs[e] || [e, this.valueAcc], this.inputs[e][1] = this.valueFn(this.inputs[e][1], n), t;
  }, r;
}(), Go = /* @__PURE__ */ H(4, [], function(t, n, e, i) {
  return new zo(t, n, e, i);
}), Vo = /* @__PURE__ */ H(
  4,
  [],
  /* @__PURE__ */ w([], Go, function(t, n, e, i) {
    return A(function(o, u) {
      var a = e(u), c = t($(a, o) ? o[a] : Ft(n, [], [], !1), u);
      return c && c["@@transducer/reduced"] ? M(o) : (o[a] = c, o);
    }, {}, i);
  })
);
const Xt = Vo;
var Yo = /* @__PURE__ */ Xt(function(r, t) {
  return r + 1;
}, 0);
const Jo = Yo;
var Ho = /* @__PURE__ */ kt(-1);
const Zo = Ho;
var Qo = /* @__PURE__ */ s(function(t, n) {
  return n == null || n !== n ? t : n;
});
const Bn = Qo;
var tu = /* @__PURE__ */ h(function(t, n, e) {
  var i = t(n), o = t(e);
  return i > o ? -1 : i < o ? 1 : 0;
});
const nu = tu;
var Dn = /* @__PURE__ */ function() {
  function r() {
    this._nativeSet = typeof Set == "function" ? /* @__PURE__ */ new Set() : null, this._items = {};
  }
  return r.prototype.add = function(t) {
    return !ur(t, !0, this);
  }, r.prototype.has = function(t) {
    return ur(t, !1, this);
  }, r;
}();
function ur(r, t, n) {
  var e = typeof r, i, o;
  switch (e) {
    case "string":
    case "number":
      return r === 0 && 1 / r === -1 / 0 ? n._items["-0"] ? !0 : (t && (n._items["-0"] = !0), !1) : n._nativeSet !== null ? t ? (i = n._nativeSet.size, n._nativeSet.add(r), o = n._nativeSet.size, o === i) : n._nativeSet.has(r) : e in n._items ? r in n._items[e] ? !0 : (t && (n._items[e][r] = !0), !1) : (t && (n._items[e] = {}, n._items[e][r] = !0), !1);
    case "boolean":
      if (e in n._items) {
        var u = r ? 1 : 0;
        return n._items[e][u] ? !0 : (t && (n._items[e][u] = !0), !1);
      } else
        return t && (n._items[e] = r ? [!1, !0] : [!0, !1]), !1;
    case "function":
      return n._nativeSet !== null ? t ? (i = n._nativeSet.size, n._nativeSet.add(r), o = n._nativeSet.size, o === i) : n._nativeSet.has(r) : e in n._items ? et(r, n._items[e]) ? !0 : (t && n._items[e].push(r), !1) : (t && (n._items[e] = [r]), !1);
    case "undefined":
      return n._items[e] ? !0 : (t && (n._items[e] = !0), !1);
    case "object":
      if (r === null)
        return n._items.null ? !0 : (t && (n._items.null = !0), !1);
    default:
      return e = Object.prototype.toString.call(r), e in n._items ? et(r, n._items[e]) ? !0 : (t && n._items[e].push(r), !1) : (t && (n._items[e] = [r]), !1);
  }
}
var ru = /* @__PURE__ */ s(function(t, n) {
  for (var e = [], i = 0, o = t.length, u = n.length, a = new Dn(), c = 0; c < u; c += 1)
    a.add(n[c]);
  for (; i < o; )
    a.add(t[i]) && (e[e.length] = t[i]), i += 1;
  return e;
});
const Lt = ru;
var eu = /* @__PURE__ */ h(function(t, n, e) {
  for (var i = [], o = 0, u = n.length; o < u; )
    !Y(t, n[o], e) && !Y(t, n[o], i) && i.push(n[o]), o += 1;
  return i;
});
const sn = eu;
var iu = /* @__PURE__ */ h(function(t, n, e) {
  var i = Array.prototype.slice.call(e, 0);
  return i.splice(t, n), i;
});
const Nr = iu;
function ou(r, t) {
  if (t == null)
    return t;
  if (T(r) && I(t))
    return Nr(r, 1, t);
  var n = {};
  for (var e in t)
    n[e] = t[e];
  return delete n[r], n;
}
function uu(r, t) {
  if (T(r) && I(t))
    return [].concat(t);
  var n = {};
  for (var e in t)
    n[e] = t[e];
  return n;
}
var au = /* @__PURE__ */ s(function r(t, n) {
  if (n == null)
    return n;
  switch (t.length) {
    case 0:
      return n;
    case 1:
      return ou(t[0], n);
    default:
      var e = t[0], i = Array.prototype.slice.call(t, 1);
      return n[e] == null ? uu(e, n) : It(e, r(i, n[e]), n);
  }
});
const Pn = au;
var su = /* @__PURE__ */ s(function(t, n) {
  return Pn([t], n);
});
const cu = su;
var fu = /* @__PURE__ */ s(function(t, n) {
  return t / n;
});
const lu = fu;
var pu = /* @__PURE__ */ function() {
  function r(t, n) {
    this.xf = n, this.n = t;
  }
  return r.prototype["@@transducer/init"] = y.init, r.prototype["@@transducer/result"] = y.result, r.prototype["@@transducer/step"] = function(t, n) {
    return this.n > 0 ? (this.n -= 1, t) : this.xf["@@transducer/step"](t, n);
  }, r;
}(), hu = /* @__PURE__ */ s(function(t, n) {
  return new pu(t, n);
}), du = /* @__PURE__ */ s(
  /* @__PURE__ */ w(["drop"], hu, function(t, n) {
    return B(Math.max(0, t), 1 / 0, n);
  })
);
const Tr = du;
var vu = /* @__PURE__ */ function() {
  function r(t, n) {
    this.xf = n, this.n = t, this.i = 0;
  }
  return r.prototype["@@transducer/init"] = y.init, r.prototype["@@transducer/result"] = y.result, r.prototype["@@transducer/step"] = function(t, n) {
    this.i += 1;
    var e = this.n === 0 ? t : this.xf["@@transducer/step"](t, n);
    return this.n >= 0 && this.i >= this.n ? M(e) : e;
  }, r;
}(), yu = /* @__PURE__ */ s(function(t, n) {
  return new vu(t, n);
}), Cn = /* @__PURE__ */ s(
  /* @__PURE__ */ w(["take"], yu, function(t, n) {
    return B(0, t < 0 ? 1 / 0 : t, n);
  })
);
function gu(r, t) {
  return Cn(r < t.length ? t.length - r : 0, t);
}
var mu = /* @__PURE__ */ function() {
  function r(t, n) {
    this.xf = n, this.pos = 0, this.full = !1, this.acc = new Array(t);
  }
  return r.prototype["@@transducer/init"] = y.init, r.prototype["@@transducer/result"] = function(t) {
    return this.acc = null, this.xf["@@transducer/result"](t);
  }, r.prototype["@@transducer/step"] = function(t, n) {
    return this.full && (t = this.xf["@@transducer/step"](t, this.acc[this.pos])), this.store(n), t;
  }, r.prototype.store = function(t) {
    this.acc[this.pos] = t, this.pos += 1, this.pos === this.acc.length && (this.pos = 0, this.full = !0);
  }, r;
}(), wu = /* @__PURE__ */ s(function(t, n) {
  return new mu(t, n);
}), $u = /* @__PURE__ */ s(
  /* @__PURE__ */ w([], wu, gu)
);
const Ou = $u;
function _u(r, t) {
  for (var n = t.length - 1; n >= 0 && r(t[n]); )
    n -= 1;
  return B(0, n + 1, t);
}
var Au = /* @__PURE__ */ function() {
  function r(t, n) {
    this.f = t, this.retained = [], this.xf = n;
  }
  return r.prototype["@@transducer/init"] = y.init, r.prototype["@@transducer/result"] = function(t) {
    return this.retained = null, this.xf["@@transducer/result"](t);
  }, r.prototype["@@transducer/step"] = function(t, n) {
    return this.f(n) ? this.retain(t, n) : this.flush(t, n);
  }, r.prototype.flush = function(t, n) {
    return t = A(this.xf["@@transducer/step"], t, this.retained), this.retained = [], this.xf["@@transducer/step"](t, n);
  }, r.prototype.retain = function(t, n) {
    return this.retained.push(n), t;
  }, r;
}(), xu = /* @__PURE__ */ s(function(t, n) {
  return new Au(t, n);
}), Iu = /* @__PURE__ */ s(
  /* @__PURE__ */ w([], xu, _u)
);
const Su = Iu;
var bu = /* @__PURE__ */ function() {
  function r(t, n) {
    this.xf = n, this.pred = t, this.lastValue = void 0, this.seenFirstValue = !1;
  }
  return r.prototype["@@transducer/init"] = y.init, r.prototype["@@transducer/result"] = y.result, r.prototype["@@transducer/step"] = function(t, n) {
    var e = !1;
    return this.seenFirstValue ? this.pred(this.lastValue, n) && (e = !0) : this.seenFirstValue = !0, this.lastValue = n, e ? t : this.xf["@@transducer/step"](t, n);
  }, r;
}(), kr = /* @__PURE__ */ s(function(t, n) {
  return new bu(t, n);
}), Eu = /* @__PURE__ */ Z(-1);
const Rn = Eu;
var ju = /* @__PURE__ */ s(
  /* @__PURE__ */ w([], kr, function(t, n) {
    var e = [], i = 1, o = n.length;
    if (o !== 0)
      for (e[0] = n[0]; i < o; )
        t(Rn(e), n[i]) || (e[e.length] = n[i]), i += 1;
    return e;
  })
);
const Mr = ju;
var Wu = /* @__PURE__ */ p(
  /* @__PURE__ */ w(
    [],
    /* @__PURE__ */ kr(W),
    /* @__PURE__ */ Mr(W)
  )
);
const Bu = Wu;
var Du = /* @__PURE__ */ function() {
  function r(t, n) {
    this.xf = n, this.f = t;
  }
  return r.prototype["@@transducer/init"] = y.init, r.prototype["@@transducer/result"] = y.result, r.prototype["@@transducer/step"] = function(t, n) {
    if (this.f) {
      if (this.f(n))
        return t;
      this.f = null;
    }
    return this.xf["@@transducer/step"](t, n);
  }, r;
}(), Pu = /* @__PURE__ */ s(function(t, n) {
  return new Du(t, n);
}), Cu = /* @__PURE__ */ s(
  /* @__PURE__ */ w(["dropWhile"], Pu, function(t, n) {
    for (var e = 0, i = n.length; e < i && t(n[e]); )
      e += 1;
    return B(e, 1 / 0, n);
  })
);
const Ru = Cu;
var qr = /* @__PURE__ */ s(function(t, n) {
  return t || n;
}), Lu = /* @__PURE__ */ s(function(t, n) {
  return rt(t) ? function() {
    return t.apply(this, arguments) || n.apply(this, arguments);
  } : Ut(qr)(t, n);
});
const Ur = Lu;
function Nu(r) {
  var t = Object.prototype.toString.call(r);
  return t === "[object Uint8ClampedArray]" || t === "[object Int8Array]" || t === "[object Uint8Array]" || t === "[object Int16Array]" || t === "[object Uint16Array]" || t === "[object Int32Array]" || t === "[object Uint32Array]" || t === "[object Float32Array]" || t === "[object Float64Array]" || t === "[object BigInt64Array]" || t === "[object BigUint64Array]";
}
var Tu = /* @__PURE__ */ p(function(t) {
  return t != null && typeof t["fantasy-land/empty"] == "function" ? t["fantasy-land/empty"]() : t != null && t.constructor != null && typeof t.constructor["fantasy-land/empty"] == "function" ? t.constructor["fantasy-land/empty"]() : t != null && typeof t.empty == "function" ? t.empty() : t != null && t.constructor != null && typeof t.constructor.empty == "function" ? t.constructor.empty() : I(t) ? [] : nt(t) ? "" : it(t) ? {} : $r(t) ? /* @__PURE__ */ function() {
    return arguments;
  }() : Nu(t) ? t.constructor.from("") : void 0;
});
const Fr = Tu;
var ku = /* @__PURE__ */ s(function(t, n) {
  return Tr(t >= 0 ? n.length - t : 0, n);
});
const Xr = ku;
var Mu = /* @__PURE__ */ s(function(r, t) {
  return W(Xr(r.length, t), r);
});
const qu = Mu;
var Uu = /* @__PURE__ */ h(function(t, n, e) {
  return W(t(n), t(e));
});
const Fu = Uu;
var Xu = /* @__PURE__ */ h(function(t, n, e) {
  return W(n[t], e[t]);
});
const Ku = Xu;
var zu = /* @__PURE__ */ s(function r(t, n) {
  if (!it(n) && !I(n))
    return n;
  var e = n instanceof Array ? [] : {}, i, o, u;
  for (o in n)
    i = t[o], u = typeof i, e[o] = u === "function" ? i(n[o]) : i && u === "object" ? r(i, n[o]) : n[o];
  return e;
});
const Gu = zu;
var Vu = /* @__PURE__ */ function() {
  function r(t, n) {
    this.xf = n, this.f = t, this.found = !1;
  }
  return r.prototype["@@transducer/init"] = y.init, r.prototype["@@transducer/result"] = function(t) {
    return this.found || (t = this.xf["@@transducer/step"](t, void 0)), this.xf["@@transducer/result"](t);
  }, r.prototype["@@transducer/step"] = function(t, n) {
    return this.f(n) && (this.found = !0, t = M(this.xf["@@transducer/step"](t, n))), t;
  }, r;
}(), Yu = /* @__PURE__ */ s(function(t, n) {
  return new Vu(t, n);
}), Ju = /* @__PURE__ */ s(
  /* @__PURE__ */ w(["find"], Yu, function(t, n) {
    for (var e = 0, i = n.length; e < i; ) {
      if (t(n[e]))
        return n[e];
      e += 1;
    }
  })
);
const Hu = Ju;
var Zu = /* @__PURE__ */ function() {
  function r(t, n) {
    this.xf = n, this.f = t, this.idx = -1, this.found = !1;
  }
  return r.prototype["@@transducer/init"] = y.init, r.prototype["@@transducer/result"] = function(t) {
    return this.found || (t = this.xf["@@transducer/step"](t, -1)), this.xf["@@transducer/result"](t);
  }, r.prototype["@@transducer/step"] = function(t, n) {
    return this.idx += 1, this.f(n) && (this.found = !0, t = M(this.xf["@@transducer/step"](t, this.idx))), t;
  }, r;
}(), Qu = /* @__PURE__ */ s(function(t, n) {
  return new Zu(t, n);
}), ta = /* @__PURE__ */ s(
  /* @__PURE__ */ w([], Qu, function(t, n) {
    for (var e = 0, i = n.length; e < i; ) {
      if (t(n[e]))
        return e;
      e += 1;
    }
    return -1;
  })
);
const na = ta;
var ra = /* @__PURE__ */ function() {
  function r(t, n) {
    this.xf = n, this.f = t;
  }
  return r.prototype["@@transducer/init"] = y.init, r.prototype["@@transducer/result"] = function(t) {
    return this.xf["@@transducer/result"](this.xf["@@transducer/step"](t, this.last));
  }, r.prototype["@@transducer/step"] = function(t, n) {
    return this.f(n) && (this.last = n), t;
  }, r;
}(), ea = /* @__PURE__ */ s(function(t, n) {
  return new ra(t, n);
}), ia = /* @__PURE__ */ s(
  /* @__PURE__ */ w([], ea, function(t, n) {
    for (var e = n.length - 1; e >= 0; ) {
      if (t(n[e]))
        return n[e];
      e -= 1;
    }
  })
);
const oa = ia;
var ua = /* @__PURE__ */ function() {
  function r(t, n) {
    this.xf = n, this.f = t, this.idx = -1, this.lastIdx = -1;
  }
  return r.prototype["@@transducer/init"] = y.init, r.prototype["@@transducer/result"] = function(t) {
    return this.xf["@@transducer/result"](this.xf["@@transducer/step"](t, this.lastIdx));
  }, r.prototype["@@transducer/step"] = function(t, n) {
    return this.idx += 1, this.f(n) && (this.lastIdx = this.idx), t;
  }, r;
}(), aa = /* @__PURE__ */ s(function(t, n) {
  return new ua(t, n);
}), sa = /* @__PURE__ */ s(
  /* @__PURE__ */ w([], aa, function(t, n) {
    for (var e = n.length - 1; e >= 0; ) {
      if (t(n[e]))
        return e;
      e -= 1;
    }
    return -1;
  })
);
const ca = sa;
var fa = /* @__PURE__ */ p(
  /* @__PURE__ */ Sr(!0)
);
const Kr = fa;
var la = /* @__PURE__ */ p(function(t) {
  return _(t.length, function(n, e) {
    var i = Array.prototype.slice.call(arguments, 0);
    return i[0] = e, i[1] = n, t.apply(this, i);
  });
});
const Kt = la;
var pa = /* @__PURE__ */ s(
  /* @__PURE__ */ St("forEach", function(t, n) {
    for (var e = n.length, i = 0; i < e; )
      t(n[i]), i += 1;
    return n;
  })
);
const k = pa;
var ha = /* @__PURE__ */ s(function(t, n) {
  for (var e = j(n), i = 0; i < e.length; ) {
    var o = e[i];
    t(n[o], o, n), i += 1;
  }
  return n;
});
const Ln = ha;
var da = /* @__PURE__ */ p(function(t) {
  for (var n = {}, e = 0; e < t.length; )
    n[t[e][0]] = t[e][1], e += 1;
  return n;
});
const va = da;
var ya = /* @__PURE__ */ s(
  /* @__PURE__ */ St(
    "groupBy",
    /* @__PURE__ */ Xt(function(r, t) {
      return r.push(t), r;
    }, [])
  )
);
const ga = ya;
var ma = /* @__PURE__ */ s(function(r, t) {
  for (var n = [], e = 0, i = t.length; e < i; ) {
    for (var o = e + 1; o < i && r(t[o - 1], t[o]); )
      o += 1;
    n.push(t.slice(e, o)), e = o;
  }
  return n;
});
const wa = ma;
var $a = /* @__PURE__ */ s(function(t, n) {
  return t > n;
});
const Oa = $a;
var _a = /* @__PURE__ */ s(function(t, n) {
  return t >= n;
});
const Aa = _a;
var xa = /* @__PURE__ */ s(function(t, n) {
  if (t.length === 0 || wt(n))
    return !1;
  for (var e = n, i = 0; i < t.length; )
    if (!wt(e) && $(t[i], e))
      e = e[t[i]], i += 1;
    else
      return !1;
  return !0;
});
const zr = xa;
var Ia = /* @__PURE__ */ s(function(t, n) {
  return zr([t], n);
});
const Sa = Ia;
var ba = /* @__PURE__ */ s(function(t, n) {
  return wt(n) ? !1 : t in n;
});
const Ea = ba;
var ja = /* @__PURE__ */ s(Ct);
const Wa = ja;
var Ba = /* @__PURE__ */ h(function(t, n, e) {
  return _(Math.max(t.length, n.length, e.length), function() {
    return t.apply(this, arguments) ? n.apply(this, arguments) : e.apply(this, arguments);
  });
});
const Da = Ba;
var Pa = /* @__PURE__ */ kt(1);
const Ca = Pa;
var Ra = /* @__PURE__ */ s(et);
const La = Ra;
var Na = /* @__PURE__ */ Xt(function(r, t) {
  return t;
}, null);
const Ta = Na;
var ka = /* @__PURE__ */ s(function(t, n) {
  return typeof n.indexOf == "function" && !I(n) ? n.indexOf(t) : Pr(n, t, 0);
});
const Ma = ka;
var qa = /* @__PURE__ */ B(0, -1);
const Ua = qa;
var Fa = /* @__PURE__ */ h(function(t, n, e) {
  return En(function(i) {
    return Y(t, i, e);
  }, n);
});
const Xa = Fa;
var Ka = /* @__PURE__ */ h(function(t, n, e) {
  t = t < e.length && t >= 0 ? t : e.length;
  var i = Array.prototype.slice.call(e, 0);
  return i.splice(t, 0, n), i;
});
const za = Ka;
var Ga = /* @__PURE__ */ h(function(t, n, e) {
  return t = t < e.length && t >= 0 ? t : e.length, [].concat(Array.prototype.slice.call(e, 0, t), n, Array.prototype.slice.call(e, t));
});
const Va = Ga;
var Ya = /* @__PURE__ */ function() {
  function r(t, n) {
    this.xf = n, this.f = t, this.set = new Dn();
  }
  return r.prototype["@@transducer/init"] = y.init, r.prototype["@@transducer/result"] = y.result, r.prototype["@@transducer/step"] = function(t, n) {
    return this.set.add(this.f(n)) ? this.xf["@@transducer/step"](t, n) : t;
  }, r;
}(), Ja = /* @__PURE__ */ s(function(t, n) {
  return new Ya(t, n);
}), Ha = /* @__PURE__ */ s(
  /* @__PURE__ */ w([], Ja, function(r, t) {
    for (var n = new Dn(), e = [], i = 0, o, u; i < t.length; )
      u = t[i], o = r(u), n.add(o) && e.push(u), i += 1;
    return e;
  })
);
const Gr = Ha;
var Za = /* @__PURE__ */ Gr(Et);
const Nn = Za;
var Qa = /* @__PURE__ */ s(function(t, n) {
  var e, i;
  return t.length > n.length ? (e = t, i = n) : (e = n, i = t), Nn(En(Kt(et)(e), i));
});
const ts = Qa;
var ns = /* @__PURE__ */ s(
  /* @__PURE__ */ St("intersperse", function(t, n) {
    for (var e = [], i = 0, o = n.length; i < o; )
      i === o - 1 ? e.push(n[i]) : e.push(n[i], t), i += 1;
    return e;
  })
);
const rs = ns;
function es(r) {
  if (r == null)
    throw new TypeError("Cannot convert undefined or null to object");
  for (var t = Object(r), n = 1, e = arguments.length; n < e; ) {
    var i = arguments[n];
    if (i != null)
      for (var o in i)
        $(o, i) && (t[o] = i[o]);
    n += 1;
  }
  return t;
}
const zt = typeof Object.assign == "function" ? Object.assign : es;
var is = /* @__PURE__ */ s(function(t, n) {
  var e = {};
  return e[t] = n, e;
});
const Vr = is;
var os = {
  "@@transducer/init": Array,
  "@@transducer/step": function(r, t) {
    return r.push(t), r;
  },
  "@@transducer/result": bt
}, us = {
  "@@transducer/init": String,
  "@@transducer/step": function(r, t) {
    return r + t;
  },
  "@@transducer/result": bt
}, as = {
  "@@transducer/init": Object,
  "@@transducer/step": function(r, t) {
    return zt(r, At(t) ? Vr(t[0], t[1]) : t);
  },
  "@@transducer/result": bt
};
function ss(r) {
  if (wn(r))
    return r;
  if (At(r))
    return os;
  if (typeof r == "string")
    return us;
  if (typeof r == "object")
    return as;
  throw new Error("Cannot create transformer for " + r);
}
var cs = /* @__PURE__ */ h(function(t, n, e) {
  return wn(t) ? A(n(t), t["@@transducer/init"](), e) : A(n(ss(t)), Ft(t, [], [], !1), e);
});
const fs = cs;
var ls = /* @__PURE__ */ p(function(t) {
  for (var n = j(t), e = n.length, i = 0, o = {}; i < e; ) {
    var u = n[i], a = t[u], c = $(a, o) ? o[a] : o[a] = [];
    c[c.length] = u, i += 1;
  }
  return o;
});
const ps = ls;
var hs = /* @__PURE__ */ p(function(t) {
  for (var n = j(t), e = n.length, i = 0, o = {}; i < e; ) {
    var u = n[i];
    o[t[u]] = u, i += 1;
  }
  return o;
});
const ds = hs;
var vs = /* @__PURE__ */ s(function(t, n) {
  return _(t + 1, function() {
    var e = arguments[t];
    if (e != null && rt(e[n]))
      return e[n].apply(e, Array.prototype.slice.call(arguments, 0, t));
    throw new TypeError(tt(e) + ' does not have a method named "' + n + '"');
  });
});
const Wt = vs;
var ys = /* @__PURE__ */ s(function(t, n) {
  return n instanceof t || n != null && (n.constructor === t || t.name === "Object" && typeof n == "object");
});
const Ot = ys;
var gs = /* @__PURE__ */ p(function(t) {
  return t != null && W(t, Fr(t));
});
const ms = gs;
var ws = /* @__PURE__ */ Wt(1, "join");
const $s = ws;
var Os = /* @__PURE__ */ p(function(t) {
  return Lr(function() {
    return Array.prototype.slice.call(arguments, 0);
  }, t);
});
const Yr = Os;
var _s = /* @__PURE__ */ p(function(t) {
  var n, e = [];
  for (n in t)
    e[e.length] = n;
  return e;
});
const As = _s;
var xs = /* @__PURE__ */ s(function(t, n) {
  if (typeof n.lastIndexOf == "function" && !I(n))
    return n.lastIndexOf(t);
  for (var e = n.length - 1; e >= 0; ) {
    if (W(n[e], t))
      return e;
    e -= 1;
  }
  return -1;
});
const Is = xs;
function cn(r) {
  return Object.prototype.toString.call(r) === "[object Number]";
}
var Ss = /* @__PURE__ */ p(function(t) {
  return t != null && cn(t.length) ? t.length : NaN;
});
const Jr = Ss;
var bs = /* @__PURE__ */ s(function(t, n) {
  return function(e) {
    return function(i) {
      return S(function(o) {
        return n(o, i);
      }, e(t(i)));
    };
  };
});
const Gt = bs;
var Es = /* @__PURE__ */ h(function(t, n, e) {
  return yr(t, Mt(n), e);
});
const Hr = Es;
var js = /* @__PURE__ */ p(function(t) {
  return Gt(Z(t), Hr(t));
});
const Ws = js;
var Bs = /* @__PURE__ */ s(function(t, n) {
  return t.map(function(e) {
    for (var i = n, o = 0, u; o < e.length; ) {
      if (i == null)
        return;
      u = e[o], i = T(u) ? Z(u, i) : i[u], o += 1;
    }
    return i;
  });
});
const Zr = Bs;
var Ds = /* @__PURE__ */ s(function(t, n) {
  return Zr([t], n)[0];
});
const F = Ds;
var Ps = /* @__PURE__ */ p(function(t) {
  return Gt(F(t), xt(t));
});
const Cs = Ps;
var Rs = /* @__PURE__ */ p(function(t) {
  return Gt(q(t), It(t));
});
const Ls = Rs;
var Ns = /* @__PURE__ */ s(function(t, n) {
  return t < n;
});
const Ts = Ns;
var ks = /* @__PURE__ */ s(function(t, n) {
  return t <= n;
});
const Ms = ks;
var qs = /* @__PURE__ */ h(function(t, n, e) {
  for (var i = 0, o = e.length, u = [], a = [n]; i < o; )
    a = t(a[0], e[i]), u[i] = a[1], i += 1;
  return [a[0], u];
});
const Us = qs;
var Fs = /* @__PURE__ */ h(function(t, n, e) {
  for (var i = e.length - 1, o = [], u = [n]; i >= 0; )
    u = t(u[0], e[i]), o[i] = u[1], i -= 1;
  return [u[0], o];
});
const Xs = Fs;
var Ks = /* @__PURE__ */ s(function(t, n) {
  return A(function(e, i) {
    return e[i] = t(n[i], i, n), e;
  }, {}, j(n));
});
const zs = Ks;
var Gs = /* @__PURE__ */ s(function(t, n) {
  return n.match(t) || [];
});
const Vs = Gs;
var Ys = /* @__PURE__ */ s(function(t, n) {
  return T(t) ? !T(n) || n < 1 ? NaN : (t % n + n) % n : NaN;
});
const Js = Ys;
var Hs = /* @__PURE__ */ h(function(t, n, e) {
  return t(e) > t(n) ? e : n;
});
const Zs = Hs;
var Qs = /* @__PURE__ */ L(kt, 0);
const Qr = Qs;
var tc = /* @__PURE__ */ p(function(t) {
  return Qr(t) / t.length;
});
const te = tc;
var nc = /* @__PURE__ */ p(function(t) {
  var n = t.length;
  if (n === 0)
    return NaN;
  var e = 2 - n % 2, i = (n - e) / 2;
  return te(Array.prototype.slice.call(t, 0).sort(function(o, u) {
    return o < u ? -1 : o > u ? 1 : 0;
  }).slice(i, i + e));
});
const rc = nc;
var ec = /* @__PURE__ */ s(function(t, n) {
  var e = {};
  return R(n.length, function() {
    var i = t.apply(this, arguments);
    return $(i, e) || (e[i] = n.apply(this, arguments)), e[i];
  });
});
const ic = ec;
var oc = /* @__PURE__ */ p(function(t) {
  return zt.apply(null, [{}].concat(t));
});
const uc = oc;
var ac = /* @__PURE__ */ h(function(t, n, e) {
  var i = {}, o;
  for (o in n)
    $(o, n) && (i[o] = $(o, e) ? t(o, n[o], e[o]) : n[o]);
  for (o in e)
    $(o, e) && !$(o, i) && (i[o] = e[o]);
  return i;
});
const Tn = ac;
var sc = /* @__PURE__ */ h(function r(t, n, e) {
  return Tn(function(i, o, u) {
    return it(o) && it(u) ? r(t, o, u) : t(i, o, u);
  }, n, e);
});
const Vt = sc;
var cc = /* @__PURE__ */ s(function(t, n) {
  return Vt(function(e, i, o) {
    return i;
  }, t, n);
});
const fc = cc;
var lc = /* @__PURE__ */ s(function(t, n) {
  return Vt(function(e, i, o) {
    return o;
  }, t, n);
});
const ne = lc;
var pc = /* @__PURE__ */ h(function(t, n, e) {
  return Vt(function(i, o, u) {
    return t(o, u);
  }, n, e);
});
const hc = pc;
var dc = /* @__PURE__ */ s(function(t, n) {
  return zt({}, n, t);
});
const vc = dc;
var yc = /* @__PURE__ */ s(function(t, n) {
  return zt({}, t, n);
});
const gc = yc;
var mc = /* @__PURE__ */ h(function(t, n, e) {
  return Tn(function(i, o, u) {
    return t(o, u);
  }, n, e);
});
const wc = mc;
var $c = /* @__PURE__ */ s(function(t, n) {
  return n < t ? n : t;
});
const Oc = $c;
var _c = /* @__PURE__ */ h(function(t, n, e) {
  return t(e) < t(n) ? e : n;
});
const Ac = _c;
function xc(r, t, n) {
  if (T(r) && I(n)) {
    var e = [].concat(n);
    return e[r] = t(e[r]), e;
  }
  var i = {};
  for (var o in n)
    i[o] = n[o];
  return i[r] = t(i[r]), i;
}
var Ic = /* @__PURE__ */ h(function r(t, n, e) {
  if (!it(e) && !I(e) || t.length === 0)
    return e;
  var i = t[0];
  if (!$(i, e))
    return e;
  if (t.length === 1)
    return xc(i, n, e);
  var o = r(Array.prototype.slice.call(t, 1), n, e[i]);
  return o === e[i] ? e : On(i, o, e);
});
const re = Ic;
var Sc = /* @__PURE__ */ h(function(t, n, e) {
  return re([t], n, e);
});
const bc = Sc;
var Ec = /* @__PURE__ */ s(function(t, n) {
  return t % n;
});
const jc = Ec;
var Wc = /* @__PURE__ */ h(function(r, t, n) {
  var e = n.length, i = n.slice(), o = r < 0 ? e + r : r, u = t < 0 ? e + t : t, a = i.splice(o, 1);
  return o < 0 || o >= n.length || u < 0 || u >= n.length ? n : [].concat(i.slice(0, u)).concat(a).concat(i.slice(u, n.length));
});
const Bc = Wc;
var Dc = /* @__PURE__ */ s(function(t, n) {
  return t * n;
});
const ee = Dc, Pc = /* @__PURE__ */ s((r, t) => (n) => r.call(void 0, ne(t, n)));
var Cc = /* @__PURE__ */ p(function(t) {
  return -t;
});
const Rc = Cc;
var Lc = /* @__PURE__ */ s(function(t, n) {
  return gr(Cr(t), n);
});
const Nc = Lc;
var Tc = /* @__PURE__ */ p(function(t) {
  var n = t < 0 ? 1 : t + 1;
  return _(n, function() {
    return Z(t, arguments);
  });
});
const kc = Tc;
var Mc = /* @__PURE__ */ h(function(t, n, e) {
  return t(n(e));
});
const qc = Mc;
function Uc(r) {
  return [r];
}
var Fc = /* @__PURE__ */ p(Uc);
const Xc = Fc;
var Kc = /* @__PURE__ */ s(function(t, n) {
  for (var e = {}, i = {}, o = 0, u = t.length; o < u; )
    i[t[o]] = 1, o += 1;
  for (var a in n)
    i.hasOwnProperty(a) || (e[a] = n[a]);
  return e;
});
const ie = Kc;
var zc = /* @__PURE__ */ H(4, [], function(t, n, e, i) {
  return t(n(e), n(i));
});
const Gc = zc;
var Vc = /* @__PURE__ */ p(function(t) {
  var n = !1, e;
  return R(t.length, function() {
    return n || (n = !0, e = t.apply(this, arguments)), e;
  });
});
const Yc = Vc;
function oe(r, t) {
  if (t == null || !rt(t.then))
    throw new TypeError("`" + r + "` expected a Promise, received " + jn(t, []));
}
var Jc = /* @__PURE__ */ s(function(t, n) {
  return oe("otherwise", n), n.then(null, t);
});
const Hc = Jc;
var ue = function(r) {
  return {
    value: r,
    map: function(t) {
      return ue(t(r));
    }
  };
}, Zc = /* @__PURE__ */ h(function(t, n, e) {
  return t(function(i) {
    return ue(n(i));
  })(e).value;
});
const ae = Zc;
var Qc = /* @__PURE__ */ s(function(t, n) {
  return [t, n];
});
const tf = Qc;
function se(r) {
  return s(function(t, n) {
    return R(Math.max(0, t.length - n.length), function() {
      return t.apply(this, r(n, arguments));
    });
  });
}
var nf = /* @__PURE__ */ se(D);
const rf = nf;
var ef = /* @__PURE__ */ se(
  /* @__PURE__ */ Kt(D)
);
const of = ef;
var uf = /* @__PURE__ */ Yr([ct, ft]);
const af = uf;
var sf = /* @__PURE__ */ h(function(t, n, e) {
  return W(F(t, e), n);
});
const cf = sf;
var ff = /* @__PURE__ */ h(function(t, n, e) {
  return Bn(t, F(n, e));
});
const ce = ff;
var lf = /* @__PURE__ */ h(function(t, n, e) {
  return t(F(n, e));
});
const pf = lf;
var hf = /* @__PURE__ */ s(function(t, n) {
  for (var e = {}, i = 0; i < t.length; )
    t[i] in n && (e[t[i]] = n[t[i]]), i += 1;
  return e;
});
const fe = hf;
var df = /* @__PURE__ */ s(function(t, n) {
  for (var e = {}, i = 0, o = t.length; i < o; ) {
    var u = t[i];
    e[u] = n[u], i += 1;
  }
  return e;
});
const le = df;
var vf = /* @__PURE__ */ s(function(t, n) {
  var e = {};
  for (var i in n)
    t(n[i], i, n) && (e[i] = n[i]);
  return e;
});
const yf = vf;
var gf = /* @__PURE__ */ s(function(t, n) {
  return D([t], n);
});
const pe = gf;
var mf = /* @__PURE__ */ L(ee, 1);
const wf = mf;
var $f = /* @__PURE__ */ s(function(t, n) {
  return _(n.length, function() {
    for (var e = [], i = 0; i < n.length; )
      e.push(n[i].call(this, arguments[i])), i += 1;
    return t.apply(this, e.concat(Array.prototype.slice.call(arguments, n.length)));
  });
});
const he = $f;
var Of = /* @__PURE__ */ he(G, [le, Et]);
const _f = Of;
function de(r, t, n) {
  return function(e) {
    return t(n(r(e)));
  };
}
var Af = /* @__PURE__ */ function() {
  function r(t, n, e) {
    this.xf = e, this.f = t, this.g = n;
  }
  return r.prototype["@@transducer/init"] = y.init, r.prototype["@@transducer/result"] = y.result, r.prototype["@@transducer/step"] = function(t, n) {
    return this.xf["@@transducer/step"](t, de(this.f, this.g, n));
  }, r;
}(), xf = /* @__PURE__ */ h(function(t, n, e) {
  return new Af(t, n, e);
}), If = /* @__PURE__ */ h(
  /* @__PURE__ */ w(["fantasy-land/promap", "promap"], xf, de)
);
const Sf = If;
var bf = /* @__PURE__ */ h(function(t, n, e) {
  return W(n, q(t, e));
});
const ve = bf;
var Ef = /* @__PURE__ */ h(function(t, n, e) {
  return Ot(t, q(n, e));
});
const jf = Ef;
var Wf = /* @__PURE__ */ h(function(t, n, e) {
  return Bn(t, q(n, e));
});
const Bf = Wf;
var Df = /* @__PURE__ */ h(function(t, n, e) {
  return t(q(n, e));
});
const Pf = Df;
var Cf = /* @__PURE__ */ s(function(t, n) {
  return t.map(function(e) {
    return F([e], n);
  });
});
const Rf = Cf;
var Lf = /* @__PURE__ */ s(function(t, n) {
  if (!(cn(t) && cn(n)))
    throw new TypeError("Both arguments to range must be numbers");
  for (var e = [], i = t; i < n; )
    e.push(i), i += 1;
  return e;
});
const Nf = Lf;
var Tf = /* @__PURE__ */ h(function(t, n, e) {
  for (var i = e.length - 1; i >= 0; ) {
    if (n = t(e[i], n), n && n["@@transducer/reduced"]) {
      n = n["@@transducer/value"];
      break;
    }
    i -= 1;
  }
  return n;
});
const ye = Tf;
var kf = /* @__PURE__ */ H(4, [], function(t, n, e, i) {
  return A(function(o, u) {
    return t(o, u) ? n(o, u) : M(o);
  }, e, i);
});
const Mf = kf;
var qf = /* @__PURE__ */ p(M);
const Uf = qf;
var Ff = /* @__PURE__ */ s(function(t, n) {
  var e = Number(n), i = 0, o;
  if (e < 0 || isNaN(e))
    throw new RangeError("n must be a non-negative number");
  for (o = new Array(e); i < e; )
    o[i] = t(i), i += 1;
  return o;
});
const ge = Ff;
var Xf = /* @__PURE__ */ s(function(t, n) {
  return ge(Mt(t), n);
});
const Kf = Xf;
var zf = /* @__PURE__ */ h(function(t, n, e) {
  return e.replace(t, n);
});
const Gf = zf;
var Vf = /* @__PURE__ */ h(function(t, n, e) {
  for (var i = 0, o = e.length, u = [n]; i < o; )
    n = t(n, e[i]), u[i + 1] = n, i += 1;
  return u;
});
const Yf = Vf;
var Jf = /* @__PURE__ */ s(function(t, n) {
  return typeof n.sequence == "function" ? n.sequence(t) : ye(function(e, i) {
    return $n(S(pe, e), i);
  }, t([]), n);
});
const me = Jf;
var Hf = /* @__PURE__ */ h(function(t, n, e) {
  return ae(t, Mt(n), e);
});
const Zf = Hf;
var Qf = /* @__PURE__ */ s(function(t, n) {
  return Array.prototype.slice.call(n, 0).sort(t);
});
const tl = Qf;
var nl = /* @__PURE__ */ s(function(t, n) {
  return Array.prototype.slice.call(n, 0).sort(function(e, i) {
    var o = t(e), u = t(i);
    return o < u ? -1 : o > u ? 1 : 0;
  });
});
const rl = nl;
var el = /* @__PURE__ */ s(function(t, n) {
  return Array.prototype.slice.call(n, 0).sort(function(e, i) {
    for (var o = 0, u = 0; o === 0 && u < t.length; )
      o = t[u](e, i), u += 1;
    return o;
  });
});
const il = el;
var ol = /* @__PURE__ */ Wt(1, "split");
const ul = ol;
var al = /* @__PURE__ */ s(function(t, n) {
  return [B(0, t, n), B(t, Jr(n), n)];
});
const sl = al;
var cl = /* @__PURE__ */ s(function(t, n) {
  if (t <= 0)
    throw new Error("First argument to splitEvery must be a positive integer");
  for (var e = [], i = 0; i < n.length; )
    e.push(B(i, i += t, n));
  return e;
});
const fl = cl;
var ll = /* @__PURE__ */ s(function(t, n) {
  for (var e = 0, i = n.length, o = []; e < i && !t(n[e]); )
    o.push(n[e]), e += 1;
  return [o, Array.prototype.slice.call(n, e)];
});
const pl = ll;
var hl = /* @__PURE__ */ H(2, [], function(t, n) {
  for (var e = [], i = [], o = 0; o < n.length; o = o + 1)
    t(n[o]) || i.push(n[o]), (o < n.length - 1 && t(n[o + 1]) || o === n.length - 1) && i.length > 0 && (e.push(i), i = []);
  return e;
});
const dl = hl;
var vl = /* @__PURE__ */ s(function(r, t) {
  return W(Cn(r.length, t), r);
});
const we = vl;
var yl = /* @__PURE__ */ s(function(t, n) {
  return Number(t) - Number(n);
});
const gl = yl;
var ml = /* @__PURE__ */ s(function(t, n) {
  return Wn(Lt(t, n), Lt(n, t));
});
const wl = ml;
var $l = /* @__PURE__ */ h(function(t, n, e) {
  return Wn(sn(t, n, e), sn(t, e, n));
});
const Ol = $l;
var _l = /* @__PURE__ */ s(function(t, n) {
  for (var e = n.length - 1; e >= 0 && t(n[e]); )
    e -= 1;
  return B(e + 1, 1 / 0, n);
});
const Al = _l;
var xl = /* @__PURE__ */ function() {
  function r(t, n) {
    this.xf = n, this.f = t;
  }
  return r.prototype["@@transducer/init"] = y.init, r.prototype["@@transducer/result"] = y.result, r.prototype["@@transducer/step"] = function(t, n) {
    return this.f(n) ? this.xf["@@transducer/step"](t, n) : M(t);
  }, r;
}(), Il = /* @__PURE__ */ s(function(t, n) {
  return new xl(t, n);
}), Sl = /* @__PURE__ */ s(
  /* @__PURE__ */ w(["takeWhile"], Il, function(t, n) {
    for (var e = 0, i = n.length; e < i && t(n[e]); )
      e += 1;
    return B(0, e, n);
  })
);
const bl = Sl;
var El = /* @__PURE__ */ function() {
  function r(t, n) {
    this.xf = n, this.f = t;
  }
  return r.prototype["@@transducer/init"] = y.init, r.prototype["@@transducer/result"] = y.result, r.prototype["@@transducer/step"] = function(t, n) {
    return this.f(n), this.xf["@@transducer/step"](t, n);
  }, r;
}(), jl = /* @__PURE__ */ s(function(t, n) {
  return new El(t, n);
}), Wl = /* @__PURE__ */ s(
  /* @__PURE__ */ w([], jl, function(t, n) {
    return t(n), n;
  })
);
const Bl = Wl;
function Dl(r) {
  return Object.prototype.toString.call(r) === "[object RegExp]";
}
var Pl = /* @__PURE__ */ s(function(t, n) {
  if (!Dl(t))
    throw new TypeError("‘test’ requires a value of type RegExp as its first argument; received " + tt(t));
  return Er(t).test(n);
});
const Cl = Pl;
var Rl = /* @__PURE__ */ s(function(t, n) {
  return oe("andThen", n), n.then(t);
});
const Ll = Rl;
var Nl = /* @__PURE__ */ Wt(0, "toLowerCase");
const Tl = Nl;
var kl = /* @__PURE__ */ p(function(t) {
  var n = [];
  for (var e in t)
    $(e, t) && (n[n.length] = [e, t[e]]);
  return n;
});
const Ml = kl;
var ql = /* @__PURE__ */ p(function(t) {
  var n = [];
  for (var e in t)
    n[n.length] = [e, t[e]];
  return n;
});
const Ul = ql;
var Fl = /* @__PURE__ */ Wt(0, "toUpperCase");
const Xl = Fl;
var Kl = /* @__PURE__ */ _(4, function(t, n, e, i) {
  return A(t(typeof n == "function" ? mr(n) : n), e, i);
});
const zl = Kl;
var Gl = /* @__PURE__ */ p(function(t) {
  for (var n = 0, e = []; n < t.length; ) {
    for (var i = t[n], o = 0; o < i.length; )
      typeof e[o] > "u" && (e[o] = []), e[o].push(i[o]), o += 1;
    n += 1;
  }
  return e;
});
const Vl = Gl;
var Yl = /* @__PURE__ */ h(function(t, n, e) {
  return typeof e["fantasy-land/traverse"] == "function" ? e["fantasy-land/traverse"](n, t) : typeof e.traverse == "function" ? e.traverse(n, t) : me(t, S(n, e));
});
const Jl = Yl;
var yt = `	
\v\f\r                　\u2028\u2029\uFEFF`, Hl = "​", Zl = typeof String.prototype.trim == "function", Ql = /* @__PURE__ */ p(!Zl || /* @__PURE__ */ yt.trim() || !/* @__PURE__ */ Hl.trim() ? function(t) {
  var n = new RegExp("^[" + yt + "][" + yt + "]*"), e = new RegExp("[" + yt + "][" + yt + "]*$");
  return t.replace(n, "").replace(e, "");
} : function(t) {
  return t.trim();
});
const tp = Ql;
var np = /* @__PURE__ */ s(function(t, n) {
  return R(t.length, function() {
    try {
      return t.apply(this, arguments);
    } catch (e) {
      return n.apply(this, D([e], arguments));
    }
  });
});
const rp = np;
var ep = /* @__PURE__ */ p(function(t) {
  return function() {
    return t(Array.prototype.slice.call(arguments, 0));
  };
});
const ip = ep;
var op = /* @__PURE__ */ p(function(t) {
  return qt(1, t);
});
const up = op;
var ap = /* @__PURE__ */ s(function(t, n) {
  return _(t, function() {
    for (var e = 1, i = n, o = 0, u; e <= t && typeof i == "function"; )
      u = e === t ? arguments.length : o + i.length, i = i.apply(this, Array.prototype.slice.call(arguments, o, u)), e += 1, o = u;
    return i;
  });
});
const sp = ap;
var cp = /* @__PURE__ */ s(function(t, n) {
  for (var e = t(n), i = []; e && e.length; )
    i[i.length] = e[0], e = t(e[1]);
  return i;
});
const fp = cp;
var lp = /* @__PURE__ */ s(
  /* @__PURE__ */ Sn(Nn, D)
);
const pp = lp;
var hp = /* @__PURE__ */ function() {
  function r(t, n) {
    this.xf = n, this.pred = t, this.items = [];
  }
  return r.prototype["@@transducer/init"] = y.init, r.prototype["@@transducer/result"] = y.result, r.prototype["@@transducer/step"] = function(t, n) {
    return Y(this.pred, n, this.items) ? t : (this.items.push(n), this.xf["@@transducer/step"](t, n));
  }, r;
}(), dp = /* @__PURE__ */ s(function(t, n) {
  return new hp(t, n);
}), vp = /* @__PURE__ */ s(
  /* @__PURE__ */ w([], dp, function(r, t) {
    for (var n = 0, e = t.length, i = [], o; n < e; )
      o = t[n], Y(r, o, i) || (i[i.length] = o), n += 1;
    return i;
  })
);
const $e = vp;
var yp = /* @__PURE__ */ h(function(t, n, e) {
  return $e(t, D(n, e));
});
const gp = yp;
var mp = /* @__PURE__ */ h(function(t, n, e) {
  return t(e) ? e : n(e);
});
const wp = mp;
var $p = /* @__PURE__ */ br(bt);
const Op = $p;
var _p = /* @__PURE__ */ h(function(t, n, e) {
  for (var i = e; !t(i); )
    i = n(i);
  return i;
});
const Ap = _p;
var xp = /* @__PURE__ */ s(function(r, t) {
  return r in t && I(t[r]) ? G(function(n) {
    return On(r, n, t);
  }, t[r]) : [t];
});
const Ip = xp;
var Sp = /* @__PURE__ */ p(function(t) {
  var n, e = [];
  for (n in t)
    e[e.length] = t[n];
  return e;
});
const bp = Sp;
var Ep = function(r) {
  return {
    value: r,
    "fantasy-land/map": function() {
      return this;
    }
  };
}, jp = /* @__PURE__ */ s(function(t, n) {
  return t(Ep)(n).value;
});
const Wp = jp;
var Bp = /* @__PURE__ */ h(function(t, n, e) {
  return t(e) ? n(e) : e;
});
const Dp = Bp;
var Pp = /* @__PURE__ */ s(function(t, n) {
  for (var e in t)
    if ($(e, t) && !t[e](n[e]))
      return !1;
  return !0;
});
const Oe = Pp;
var Cp = /* @__PURE__ */ s(function(t, n) {
  for (var e in t)
    if ($(e, t) && t[e](n[e]))
      return !0;
  return !1;
});
const Rp = Cp;
var Lp = /* @__PURE__ */ s(function(t, n) {
  return Oe(S(W, t), n);
});
const Np = Lp;
var Tp = /* @__PURE__ */ s(function(r, t) {
  return ft(Kt(et)(r), t);
});
const kp = Tp;
var Mp = /* @__PURE__ */ s(function(t, n) {
  return !!(!t ^ !n);
});
const qp = Mp;
var Up = /* @__PURE__ */ s(function(t, n) {
  for (var e = 0, i = t.length, o, u = n.length, a = []; e < i; ) {
    for (o = 0; o < u; )
      a[a.length] = [t[e], n[o]], o += 1;
    e += 1;
  }
  return a;
});
const Fp = Up;
var Xp = /* @__PURE__ */ s(function(t, n) {
  for (var e = [], i = 0, o = Math.min(t.length, n.length); i < o; )
    e[i] = [t[i], n[i]], i += 1;
  return e;
});
const Kp = Xp;
var zp = /* @__PURE__ */ s(function(t, n) {
  for (var e = 0, i = Math.min(t.length, n.length), o = {}; e < i; )
    o[t[e]] = n[e], e += 1;
  return o;
});
const Gp = zp;
var Vp = /* @__PURE__ */ h(function(t, n, e) {
  for (var i = [], o = 0, u = Math.min(n.length, e.length); o < u; )
    i[o] = t(n[o], e[o]), o += 1;
  return i;
});
const Yp = Vp;
var Jp = /* @__PURE__ */ p(function(t) {
  return _(t.length, function() {
    var e = arguments;
    return function() {
      return t.apply(this, e);
    };
  });
});
const Hp = Jp, Zp = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  F: ii,
  T: ui,
  __: ai,
  add: kt,
  addIndex: fi,
  adjust: yr,
  all: gr,
  allPass: bi,
  always: Mt,
  and: Or,
  andThen: Ll,
  any: _r,
  anyPass: Pi,
  ap: $n,
  aperture: Ti,
  append: Mi,
  apply: Ar,
  applySpec: Xi,
  applyTo: zi,
  ascend: Vi,
  assoc: It,
  assocPath: xt,
  binary: to,
  bind: wr,
  both: _n,
  call: eo,
  chain: br,
  clamp: fo,
  clone: po,
  collectBy: vo,
  comparator: go,
  complement: jr,
  compose: Sn,
  composeWith: bo,
  concat: Wn,
  cond: To,
  construct: Uo,
  constructN: Rr,
  converge: Lr,
  count: Ko,
  countBy: Jo,
  curry: jt,
  curryN: _,
  dec: Zo,
  defaultTo: Bn,
  descend: nu,
  difference: Lt,
  differenceWith: sn,
  dissoc: cu,
  dissocPath: Pn,
  divide: lu,
  drop: Tr,
  dropLast: Ou,
  dropLastWhile: Su,
  dropRepeats: Bu,
  dropRepeatsWith: Mr,
  dropWhile: Ru,
  either: Ur,
  empty: Fr,
  endsWith: qu,
  eqBy: Fu,
  eqProps: Ku,
  equals: W,
  evolve: Gu,
  filter: ct,
  find: Hu,
  findIndex: na,
  findLast: oa,
  findLastIndex: ca,
  flatten: Kr,
  flip: Kt,
  forEach: k,
  forEachObjIndexed: Ln,
  fromPairs: va,
  groupBy: ga,
  groupWith: wa,
  gt: Oa,
  gte: Aa,
  has: Sa,
  hasIn: Ea,
  hasPath: zr,
  head: Br,
  identical: Wa,
  identity: Et,
  ifElse: Da,
  inc: Ca,
  includes: La,
  indexBy: Ta,
  indexOf: Ma,
  init: Ua,
  innerJoin: Xa,
  insert: za,
  insertAll: Va,
  intersection: ts,
  intersperse: rs,
  into: fs,
  invert: ps,
  invertObj: ds,
  invoker: Wt,
  is: Ot,
  isEmpty: ms,
  isNil: wt,
  join: $s,
  juxt: Yr,
  keys: j,
  keysIn: As,
  last: Rn,
  lastIndexOf: Is,
  length: Jr,
  lens: Gt,
  lensIndex: Ws,
  lensPath: Cs,
  lensProp: Ls,
  lift: Ut,
  liftN: Ir,
  lt: Ts,
  lte: Ms,
  map: S,
  mapAccum: Us,
  mapAccumRight: Xs,
  mapObjIndexed: zs,
  match: Vs,
  mathMod: Js,
  max: at,
  maxBy: Zs,
  mean: te,
  median: rc,
  memoizeWith: ic,
  mergeAll: uc,
  mergeDeepLeft: fc,
  mergeDeepRight: ne,
  mergeDeepWith: hc,
  mergeDeepWithKey: Vt,
  mergeLeft: vc,
  mergeRight: gc,
  mergeWith: wc,
  mergeWithKey: Tn,
  min: Oc,
  minBy: Ac,
  modify: bc,
  modifyPath: re,
  modulo: jc,
  move: Bc,
  multiply: ee,
  nAry: qt,
  negate: Rc,
  none: Nc,
  not: An,
  nth: Z,
  nthArg: kc,
  o: qc,
  objOf: Vr,
  of: Xc,
  omit: ie,
  on: Gc,
  once: Yc,
  or: qr,
  otherwise: Hc,
  over: ae,
  pair: tf,
  partial: rf,
  partialObject: Pc,
  partialRight: of,
  partition: af,
  path: F,
  pathEq: cf,
  pathOr: ce,
  pathSatisfies: pf,
  paths: Zr,
  pick: fe,
  pickAll: le,
  pickBy: yf,
  pipe: Wr,
  pipeWith: Dr,
  pluck: st,
  prepend: pe,
  product: wf,
  project: _f,
  promap: Sf,
  prop: q,
  propEq: ve,
  propIs: jf,
  propOr: Bf,
  propSatisfies: Pf,
  props: Rf,
  range: Nf,
  reduce: L,
  reduceBy: Xt,
  reduceRight: ye,
  reduceWhile: Mf,
  reduced: Uf,
  reject: ft,
  remove: Nr,
  repeat: Kf,
  replace: Gf,
  reverse: In,
  scan: Yf,
  sequence: me,
  set: Zf,
  slice: B,
  sort: tl,
  sortBy: rl,
  sortWith: il,
  split: ul,
  splitAt: sl,
  splitEvery: fl,
  splitWhen: pl,
  splitWhenever: dl,
  startsWith: we,
  subtract: gl,
  sum: Qr,
  symmetricDifference: wl,
  symmetricDifferenceWith: Ol,
  tail: xn,
  take: Cn,
  takeLast: Xr,
  takeLastWhile: Al,
  takeWhile: bl,
  tap: Bl,
  test: Cl,
  thunkify: Hp,
  times: ge,
  toLower: Tl,
  toPairs: Ml,
  toPairsIn: Ul,
  toString: tt,
  toUpper: Xl,
  transduce: zl,
  transpose: Vl,
  traverse: Jl,
  trim: tp,
  tryCatch: rp,
  type: $t,
  unapply: ip,
  unary: up,
  uncurryN: sp,
  unfold: fp,
  union: pp,
  unionWith: gp,
  uniq: Nn,
  uniqBy: Gr,
  uniqWith: $e,
  unless: wp,
  unnest: Op,
  until: Ap,
  unwind: Ip,
  update: Hr,
  useWith: he,
  values: xr,
  valuesIn: bp,
  view: Wp,
  when: Dp,
  where: Oe,
  whereAny: Rp,
  whereEq: Np,
  without: kp,
  xor: qp,
  xprod: Fp,
  zip: Kp,
  zipObj: Gp,
  zipWith: Yp
}, Symbol.toStringTag, { value: "Module" })), Qp = (r, t) => t.some((n) => r instanceof n);
let ar, sr;
function th() {
  return ar || (ar = [
    IDBDatabase,
    IDBObjectStore,
    IDBIndex,
    IDBCursor,
    IDBTransaction
  ]);
}
function nh() {
  return sr || (sr = [
    IDBCursor.prototype.advance,
    IDBCursor.prototype.continue,
    IDBCursor.prototype.continuePrimaryKey
  ]);
}
const _e = /* @__PURE__ */ new WeakMap(), fn = /* @__PURE__ */ new WeakMap(), Ae = /* @__PURE__ */ new WeakMap(), en = /* @__PURE__ */ new WeakMap(), kn = /* @__PURE__ */ new WeakMap();
function rh(r) {
  const t = new Promise((n, e) => {
    const i = () => {
      r.removeEventListener("success", o), r.removeEventListener("error", u);
    }, o = () => {
      n(N(r.result)), i();
    }, u = () => {
      e(r.error), i();
    };
    r.addEventListener("success", o), r.addEventListener("error", u);
  });
  return t.then((n) => {
    n instanceof IDBCursor && _e.set(n, r);
  }).catch(() => {
  }), kn.set(t, r), t;
}
function eh(r) {
  if (fn.has(r))
    return;
  const t = new Promise((n, e) => {
    const i = () => {
      r.removeEventListener("complete", o), r.removeEventListener("error", u), r.removeEventListener("abort", u);
    }, o = () => {
      n(), i();
    }, u = () => {
      e(r.error || new DOMException("AbortError", "AbortError")), i();
    };
    r.addEventListener("complete", o), r.addEventListener("error", u), r.addEventListener("abort", u);
  });
  fn.set(r, t);
}
let ln = {
  get(r, t, n) {
    if (r instanceof IDBTransaction) {
      if (t === "done")
        return fn.get(r);
      if (t === "objectStoreNames")
        return r.objectStoreNames || Ae.get(r);
      if (t === "store")
        return n.objectStoreNames[1] ? void 0 : n.objectStore(n.objectStoreNames[0]);
    }
    return N(r[t]);
  },
  set(r, t, n) {
    return r[t] = n, !0;
  },
  has(r, t) {
    return r instanceof IDBTransaction && (t === "done" || t === "store") ? !0 : t in r;
  }
};
function ih(r) {
  ln = r(ln);
}
function oh(r) {
  return r === IDBDatabase.prototype.transaction && !("objectStoreNames" in IDBTransaction.prototype) ? function(t, ...n) {
    const e = r.call(on(this), t, ...n);
    return Ae.set(e, t.sort ? t.sort() : [t]), N(e);
  } : nh().includes(r) ? function(...t) {
    return r.apply(on(this), t), N(_e.get(this));
  } : function(...t) {
    return N(r.apply(on(this), t));
  };
}
function uh(r) {
  return typeof r == "function" ? oh(r) : (r instanceof IDBTransaction && eh(r), Qp(r, th()) ? new Proxy(r, ln) : r);
}
function N(r) {
  if (r instanceof IDBRequest)
    return rh(r);
  if (en.has(r))
    return en.get(r);
  const t = uh(r);
  return t !== r && (en.set(r, t), kn.set(t, r)), t;
}
const on = (r) => kn.get(r);
function ah(r, t, { blocked: n, upgrade: e, blocking: i, terminated: o } = {}) {
  const u = indexedDB.open(r, t), a = N(u);
  return e && u.addEventListener("upgradeneeded", (c) => {
    e(N(u.result), c.oldVersion, c.newVersion, N(u.transaction), c);
  }), n && u.addEventListener("blocked", (c) => n(
    // Casting due to https://github.com/microsoft/TypeScript-DOM-lib-generator/pull/1405
    c.oldVersion,
    c.newVersion,
    c
  )), a.then((c) => {
    o && c.addEventListener("close", () => o()), i && c.addEventListener("versionchange", (f) => i(f.oldVersion, f.newVersion, f));
  }).catch(() => {
  }), a;
}
function sh(r, { blocked: t } = {}) {
  const n = indexedDB.deleteDatabase(r);
  return t && n.addEventListener("blocked", (e) => t(
    // Casting due to https://github.com/microsoft/TypeScript-DOM-lib-generator/pull/1405
    e.oldVersion,
    e
  )), N(n).then(() => {
  });
}
const ch = ["get", "getKey", "getAll", "getAllKeys", "count"], fh = ["put", "add", "delete", "clear"], un = /* @__PURE__ */ new Map();
function cr(r, t) {
  if (!(r instanceof IDBDatabase && !(t in r) && typeof t == "string"))
    return;
  if (un.get(t))
    return un.get(t);
  const n = t.replace(/FromIndex$/, ""), e = t !== n, i = fh.includes(n);
  if (
    // Bail if the target doesn't exist on the target. Eg, getAll isn't in Edge.
    !(n in (e ? IDBIndex : IDBObjectStore).prototype) || !(i || ch.includes(n))
  )
    return;
  const o = async function(u, ...a) {
    const c = this.transaction(u, i ? "readwrite" : "readonly");
    let f = c.store;
    return e && (f = f.index(a.shift())), (await Promise.all([
      f[n](...a),
      i && c.done
    ]))[0];
  };
  return un.set(t, o), o;
}
ih((r) => ({
  ...r,
  get: (t, n, e) => cr(t, n) || r.get(t, n, e),
  has: (t, n) => !!cr(t, n) || r.has(t, n)
}));
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
var pn = function(r, t) {
  return pn = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, e) {
    n.__proto__ = e;
  } || function(n, e) {
    for (var i in e)
      Object.prototype.hasOwnProperty.call(e, i) && (n[i] = e[i]);
  }, pn(r, t);
};
function x(r, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Class extends value " + String(t) + " is not a constructor or null");
  pn(r, t);
  function n() {
    this.constructor = r;
  }
  r.prototype = t === null ? Object.create(t) : (n.prototype = t.prototype, new n());
}
var Mn = function(r) {
  var t = "[object " + r + "]";
  return function(n) {
    return lh(n) === t;
  };
}, lh = function(r) {
  return Object.prototype.toString.call(r);
}, ot = function(r) {
  return r instanceof Date ? r.getTime() : lt(r) ? r.map(ot) : r && typeof r.toJSON == "function" ? r.toJSON() : r;
}, lt = Mn("Array"), ph = Mn("Object"), hh = Mn("Function"), dh = function(r) {
  return r && (r.constructor === Object || r.constructor === Array || r.constructor.toString() === "function Object() { [native code] }" || r.constructor.toString() === "function Array() { [native code] }") && !r.toJSON;
}, hn = function(r, t) {
  if (r == null && r == t || r === t)
    return !0;
  if (Object.prototype.toString.call(r) !== Object.prototype.toString.call(t))
    return !1;
  if (lt(r)) {
    if (r.length !== t.length)
      return !1;
    for (var n = 0, e = r.length; n < e; n++)
      if (!hn(r[n], t[n]))
        return !1;
    return !0;
  } else if (ph(r)) {
    if (Object.keys(r).length !== Object.keys(t).length)
      return !1;
    for (var i in r)
      if (!hn(r[i], t[i]))
        return !1;
    return !0;
  }
  return !1;
}, dn = function(r, t, n, e, i, o) {
  var u = t[e];
  if (lt(r) && isNaN(Number(u))) {
    for (var a = 0, c = r.length; a < c; a++)
      if (!dn(r[a], t, n, e, a, r))
        return !1;
  }
  return e === t.length || r == null ? n(r, i, o, e === 0) : dn(r[u], t, n, e + 1, u, r);
}, P = (
  /** @class */
  function() {
    function r(t, n, e, i) {
      this.params = t, this.owneryQuery = n, this.options = e, this.name = i, this.init();
    }
    return r.prototype.init = function() {
    }, r.prototype.reset = function() {
      this.done = !1, this.keep = !1;
    }, r;
  }()
), qn = (
  /** @class */
  function(r) {
    x(t, r);
    function t(n, e, i, o) {
      var u = r.call(this, n, e, i) || this;
      return u.children = o, u;
    }
    return t.prototype.reset = function() {
      this.keep = !1, this.done = !1;
      for (var n = 0, e = this.children.length; n < e; n++)
        this.children[n].reset();
    }, t.prototype.childrenNext = function(n, e, i, o) {
      for (var u = !0, a = !0, c = 0, f = this.children.length; c < f; c++) {
        var l = this.children[c];
        if (l.done || l.next(n, e, i, o), l.keep || (a = !1), l.done) {
          if (!l.keep)
            break;
        } else
          u = !1;
      }
      this.done = u, this.keep = a;
    }, t;
  }(P)
), xe = (
  /** @class */
  function(r) {
    x(t, r);
    function t(n, e, i, o, u) {
      var a = r.call(this, n, e, i, o) || this;
      return a.name = u, a;
    }
    return t;
  }(qn)
), vh = (
  /** @class */
  function(r) {
    x(t, r);
    function t() {
      var n = r !== null && r.apply(this, arguments) || this;
      return n.propop = !0, n;
    }
    return t.prototype.next = function(n, e, i, o) {
      this.childrenNext(n, e, i, o);
    }, t;
  }(qn)
), vn = (
  /** @class */
  function(r) {
    x(t, r);
    function t(n, e, i, o, u) {
      var a = r.call(this, e, i, o, u) || this;
      return a.keyPath = n, a.propop = !0, a._nextNestedValue = function(c, f, l, d) {
        return a.childrenNext(c, f, l, d), !a.done;
      }, a;
    }
    return t.prototype.next = function(n, e, i) {
      dn(n, this.keyPath, this._nextNestedValue, 0, e, i);
    }, t;
  }(qn)
), Un = function(r, t) {
  if (r instanceof Function)
    return r;
  if (r instanceof RegExp)
    return function(e) {
      var i = typeof e == "string" && r.test(e);
      return r.lastIndex = 0, i;
    };
  var n = ot(r);
  return function(e) {
    return t(n, ot(e));
  };
}, K = (
  /** @class */
  function(r) {
    x(t, r);
    function t() {
      var n = r !== null && r.apply(this, arguments) || this;
      return n.propop = !0, n;
    }
    return t.prototype.init = function() {
      this._test = Un(this.params, this.options.compare);
    }, t.prototype.next = function(n, e, i) {
      (!Array.isArray(i) || i.hasOwnProperty(e)) && this._test(n, e, i) && (this.done = !0, this.keep = !0);
    }, t;
  }(P)
), yh = (
  /** @class */
  function(r) {
    x(t, r);
    function t() {
      var n = r !== null && r.apply(this, arguments) || this;
      return n.propop = !0, n;
    }
    return t.prototype.next = function() {
      this.done = !0, this.keep = !1;
    }, t;
  }(P)
), gh = function(r) {
  return function(t, n, e, i) {
    return t == null ? new yh(t, n, e, i) : r(t, n, e, i);
  };
}, Yt = function(r) {
  return gh(function(t, n, e, i) {
    var o = typeof ot(t), u = r(t);
    return new K(function(a) {
      return typeof ot(a) === o && u(a);
    }, n, e, i);
  });
}, mh = function(r, t, n, e) {
  var i = e.operations[r];
  return i || Ie(r), i(t, n, e, r);
}, Ie = function(r) {
  throw new Error("Unsupported operation: " + r);
}, Se = function(r, t) {
  for (var n in r)
    if (t.operations.hasOwnProperty(n) || n.charAt(0) === "$")
      return !0;
  return !1;
}, wh = function(r, t, n, e, i) {
  if (Se(t, i)) {
    var o = be(t, n, i), u = o[0], a = o[1];
    if (a.length)
      throw new Error("Property queries must contain only operations, or exact objects.");
    return new vn(r, t, e, i, u);
  }
  return new vn(r, t, e, i, [
    new K(t, e, i)
  ]);
}, pt = function(r, t, n) {
  t === void 0 && (t = null);
  var e = n === void 0 ? {} : n, i = e.compare, o = e.operations, u = {
    compare: i || hn,
    operations: Object.assign({}, o || {})
  }, a = be(r, null, u), c = a[0], f = a[1], l = [];
  return c.length && l.push(new vn([], r, t, u, c)), l.push.apply(l, f), l.length === 1 ? l[0] : new vh(r, t, u, l);
}, be = function(r, t, n) {
  var e = [], i = [];
  if (!dh(r))
    return e.push(new K(r, r, n)), [e, i];
  for (var o in r)
    if (n.operations.hasOwnProperty(o)) {
      var u = mh(o, r[o], r, n);
      if (u && !u.propop && t && !n.operations[t])
        throw new Error("Malformed query. " + o + " cannot be matched against property.");
      u != null && e.push(u);
    } else
      o.charAt(0) === "$" ? Ie(o) : i.push(wh(o.split("."), r[o], o, r, n));
  return [e, i];
}, $h = function(r) {
  return function(t, n, e) {
    return r.reset(), r.next(t, n, e), r.keep;
  };
}, Oh = (
  /** @class */
  function(r) {
    x(t, r);
    function t() {
      var n = r !== null && r.apply(this, arguments) || this;
      return n.propop = !0, n;
    }
    return t.prototype.init = function() {
      this._test = Un(this.params, this.options.compare);
    }, t.prototype.reset = function() {
      r.prototype.reset.call(this), this.keep = !0;
    }, t.prototype.next = function(n) {
      this._test(n) && (this.done = !0, this.keep = !1);
    }, t;
  }(P)
), _h = (
  /** @class */
  function(r) {
    x(t, r);
    function t() {
      var n = r !== null && r.apply(this, arguments) || this;
      return n.propop = !0, n;
    }
    return t.prototype.init = function() {
      if (!this.params || typeof this.params != "object")
        throw new Error("Malformed query. $elemMatch must by an object.");
      this._queryOperation = pt(this.params, this.owneryQuery, this.options);
    }, t.prototype.reset = function() {
      r.prototype.reset.call(this), this._queryOperation.reset();
    }, t.prototype.next = function(n) {
      if (lt(n)) {
        for (var e = 0, i = n.length; e < i; e++) {
          this._queryOperation.reset();
          var o = n[e];
          this._queryOperation.next(o, e, n, !1), this.keep = this.keep || this._queryOperation.keep;
        }
        this.done = !0;
      } else
        this.done = !1, this.keep = !1;
    }, t;
  }(P)
), Ah = (
  /** @class */
  function(r) {
    x(t, r);
    function t() {
      var n = r !== null && r.apply(this, arguments) || this;
      return n.propop = !0, n;
    }
    return t.prototype.init = function() {
      this._queryOperation = pt(this.params, this.owneryQuery, this.options);
    }, t.prototype.reset = function() {
      r.prototype.reset.call(this), this._queryOperation.reset();
    }, t.prototype.next = function(n, e, i, o) {
      this._queryOperation.next(n, e, i, o), this.done = this._queryOperation.done, this.keep = !this._queryOperation.keep;
    }, t;
  }(P)
), Ee = (
  /** @class */
  function(r) {
    x(t, r);
    function t() {
      var n = r !== null && r.apply(this, arguments) || this;
      return n.propop = !0, n;
    }
    return t.prototype.init = function() {
    }, t.prototype.next = function(n) {
      lt(n) && n.length === this.params && (this.done = !0, this.keep = !0);
    }, t;
  }(P)
), je = function(r) {
  if (r.length === 0)
    throw new Error("$and/$or/$nor must be a nonempty array");
}, We = (
  /** @class */
  function(r) {
    x(t, r);
    function t() {
      var n = r !== null && r.apply(this, arguments) || this;
      return n.propop = !1, n;
    }
    return t.prototype.init = function() {
      var n = this;
      je(this.params), this._ops = this.params.map(function(e) {
        return pt(e, null, n.options);
      });
    }, t.prototype.reset = function() {
      this.done = !1, this.keep = !1;
      for (var n = 0, e = this._ops.length; n < e; n++)
        this._ops[n].reset();
    }, t.prototype.next = function(n, e, i) {
      for (var o = !1, u = !1, a = 0, c = this._ops.length; a < c; a++) {
        var f = this._ops[a];
        if (f.next(n, e, i), f.keep) {
          o = !0, u = f.keep;
          break;
        }
      }
      this.keep = u, this.done = o;
    }, t;
  }(P)
), xh = (
  /** @class */
  function(r) {
    x(t, r);
    function t() {
      var n = r !== null && r.apply(this, arguments) || this;
      return n.propop = !1, n;
    }
    return t.prototype.next = function(n, e, i) {
      r.prototype.next.call(this, n, e, i), this.keep = !this.keep;
    }, t;
  }(We)
), Be = (
  /** @class */
  function(r) {
    x(t, r);
    function t() {
      var n = r !== null && r.apply(this, arguments) || this;
      return n.propop = !0, n;
    }
    return t.prototype.init = function() {
      var n = this;
      this._testers = this.params.map(function(e) {
        if (Se(e, n.options))
          throw new Error("cannot nest $ under " + n.name.toLowerCase());
        return Un(e, n.options.compare);
      });
    }, t.prototype.next = function(n, e, i) {
      for (var o = !1, u = !1, a = 0, c = this._testers.length; a < c; a++) {
        var f = this._testers[a];
        if (f(n)) {
          o = !0, u = !0;
          break;
        }
      }
      this.keep = u, this.done = o;
    }, t;
  }(P)
), Ih = (
  /** @class */
  function(r) {
    x(t, r);
    function t(n, e, i, o) {
      var u = r.call(this, n, e, i, o) || this;
      return u.propop = !0, u._in = new Be(n, e, i, o), u;
    }
    return t.prototype.next = function(n, e, i, o) {
      this._in.next(n, e, i), lt(i) && !o ? this._in.keep ? (this.keep = !1, this.done = !0) : e == i.length - 1 && (this.keep = !0, this.done = !0) : (this.keep = !this._in.keep, this.done = !0);
    }, t.prototype.reset = function() {
      r.prototype.reset.call(this), this._in.reset();
    }, t;
  }(P)
), Sh = (
  /** @class */
  function(r) {
    x(t, r);
    function t() {
      var n = r !== null && r.apply(this, arguments) || this;
      return n.propop = !0, n;
    }
    return t.prototype.next = function(n, e, i) {
      i.hasOwnProperty(e) === this.params && (this.done = !0, this.keep = !0);
    }, t;
  }(P)
), bh = (
  /** @class */
  function(r) {
    x(t, r);
    function t(n, e, i, o) {
      var u = r.call(this, n, e, i, n.map(function(a) {
        return pt(a, e, i);
      }), o) || this;
      return u.propop = !1, je(n), u;
    }
    return t.prototype.next = function(n, e, i, o) {
      this.childrenNext(n, e, i, o);
    }, t;
  }(xe)
), Eh = (
  /** @class */
  function(r) {
    x(t, r);
    function t(n, e, i, o) {
      var u = r.call(this, n, e, i, n.map(function(a) {
        return pt(a, e, i);
      }), o) || this;
      return u.propop = !0, u;
    }
    return t.prototype.next = function(n, e, i, o) {
      this.childrenNext(n, e, i, o);
    }, t;
  }(xe)
), jh = function(r, t, n) {
  return new K(r, t, n);
}, Wh = function(r, t, n, e) {
  return new Oh(r, t, n, e);
}, Bh = function(r, t, n, e) {
  return new We(r, t, n, e);
}, Dh = function(r, t, n, e) {
  return new xh(r, t, n, e);
}, Ph = function(r, t, n, e) {
  return new _h(r, t, n, e);
}, Ch = function(r, t, n, e) {
  return new Ih(r, t, n, e);
}, Rh = function(r, t, n, e) {
  return new Be(r, t, n, e);
}, Lh = Yt(function(r) {
  return function(t) {
    return t < r;
  };
}), Nh = Yt(function(r) {
  return function(t) {
    return t <= r;
  };
}), Th = Yt(function(r) {
  return function(t) {
    return t > r;
  };
}), kh = Yt(function(r) {
  return function(t) {
    return t >= r;
  };
}), Mh = function(r, t, n) {
  var e = r[0], i = r[1];
  return new K(function(o) {
    return ot(o) % e === i;
  }, t, n);
}, qh = function(r, t, n, e) {
  return new Sh(r, t, n, e);
}, Uh = function(r, t, n) {
  return new K(new RegExp(r, t.$options), t, n);
}, Fh = function(r, t, n, e) {
  return new Ah(r, t, n, e);
}, fr = {
  number: function(r) {
    return typeof r == "number";
  },
  string: function(r) {
    return typeof r == "string";
  },
  bool: function(r) {
    return typeof r == "boolean";
  },
  array: function(r) {
    return Array.isArray(r);
  },
  null: function(r) {
    return r === null;
  },
  timestamp: function(r) {
    return r instanceof Date;
  }
}, Xh = function(r, t, n) {
  return new K(function(e) {
    if (typeof r == "string") {
      if (!fr[r])
        throw new Error("Type alias does not exist");
      return fr[r](e);
    }
    return e != null ? e instanceof r || e.constructor === r : !1;
  }, t, n);
}, Kh = function(r, t, n, e) {
  return new bh(r, t, n, e);
}, zh = function(r, t, n, e) {
  return new Eh(r, t, n, e);
}, Gh = function(r, t, n) {
  return new Ee(r, t, n, "$size");
}, Vh = function() {
  return null;
}, Yh = function(r, t, n) {
  var e;
  if (hh(r))
    e = r;
  else if (!process.env.CSP_ENABLED)
    e = new Function("obj", "return " + r);
  else
    throw new Error('In CSP mode, sift does not support strings in "$where" condition');
  return new K(function(i) {
    return e.bind(i)(i);
  }, t, n);
}, Jh = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  $Size: Ee,
  $eq: jh,
  $ne: Wh,
  $or: Bh,
  $nor: Dh,
  $elemMatch: Ph,
  $nin: Ch,
  $in: Rh,
  $lt: Lh,
  $lte: Nh,
  $gt: Th,
  $gte: kh,
  $mod: Mh,
  $exists: qh,
  $regex: Uh,
  $not: Fh,
  $type: Xh,
  $and: Kh,
  $all: zh,
  $size: Gh,
  $options: Vh,
  $where: Yh
}), Hh = function(r, t, n) {
  var e = n === void 0 ? {} : n, i = e.compare, o = e.operations;
  return pt(r, t, {
    compare: i,
    operations: Object.assign({}, Jh, o || {})
  });
}, Zh = function(r, t) {
  t === void 0 && (t = {});
  var n = Hh(r, null, t);
  return $h(n);
};
const ht = Zh;
var Q = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function Fn(r) {
  return r && r.__esModule && Object.prototype.hasOwnProperty.call(r, "default") ? r.default : r;
}
function De(r) {
  if (r.__esModule)
    return r;
  var t = r.default;
  if (typeof t == "function") {
    var n = function e() {
      return this instanceof e ? Reflect.construct(t, arguments, this.constructor) : t.apply(this, arguments);
    };
    n.prototype = t.prototype;
  } else
    n = {};
  return Object.defineProperty(n, "__esModule", { value: !0 }), Object.keys(r).forEach(function(e) {
    var i = Object.getOwnPropertyDescriptor(r, e);
    Object.defineProperty(n, e, i.get ? i : {
      enumerable: !0,
      get: function() {
        return r[e];
      }
    });
  }), n;
}
var Pe = {}, Qh = function(r, t, n, e, i, o, u, a) {
  if (process.env.NODE_ENV !== "production" && t === void 0)
    throw new Error("invariant requires an error message argument");
  if (!r) {
    var c;
    if (t === void 0)
      c = new Error(
        "Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings."
      );
    else {
      var f = [n, e, i, o, u, a], l = 0;
      c = new Error(
        t.replace(/%s/g, function() {
          return f[l++];
        })
      ), c.name = "Invariant Violation";
    }
    throw c.framesToPop = 1, c;
  }
}, td = Qh;
const J = /* @__PURE__ */ Fn(td), U = function(r) {
  return typeof r == "function";
}, nd = function(r) {
  return typeof r == "symbol" || typeof r == "object" && Object.prototype.toString.call(r) === "[object Symbol]";
}, Ce = function(r) {
  return r.length === 0;
}, yn = function(r) {
  return r.toString();
}, Rt = function(r) {
  return typeof r == "string";
};
var Xn = "/", mt = "||";
function rd(r) {
  return Rt(r) || U(r) || nd(r);
}
function ed(r) {
  return Ce(r) ? !1 : r.every(rd);
}
function id() {
  for (var r = arguments.length, t = new Array(r), n = 0; n < r; n++)
    t[n] = arguments[n];
  J(ed(t), "Expected action types to be strings, symbols, or action creators");
  var e = t.map(yn).join(mt);
  return {
    toString: function() {
      return e;
    }
  };
}
const V = function(r) {
  return r;
}, lr = function(r) {
  return r === null;
};
function Nt(r, t, n) {
  t === void 0 && (t = V), J(U(t) || lr(t), "Expected payloadCreator to be a function, undefined or null");
  var e = lr(t) || t === V ? V : function(a) {
    for (var c = arguments.length, f = new Array(c > 1 ? c - 1 : 0), l = 1; l < c; l++)
      f[l - 1] = arguments[l];
    return a instanceof Error ? a : t.apply(void 0, [a].concat(f));
  }, i = U(n), o = r.toString(), u = function() {
    var c = e.apply(void 0, arguments), f = {
      type: r
    };
    return c instanceof Error && (f.error = !0), c !== void 0 && (f.payload = c), i && (f.meta = n.apply(void 0, arguments)), f;
  };
  return u.toString = function() {
    return o;
  }, u;
}
const ut = function(r) {
  if (typeof r != "object" || r === null)
    return !1;
  for (var t = r; Object.getPrototypeOf(t) !== null; )
    t = Object.getPrototypeOf(t);
  return Object.getPrototypeOf(r) === t;
}, pr = function(r) {
  return Array.isArray(r);
}, Re = function(r) {
  return r == null;
}, od = function(r) {
  return r[r.length - 1];
};
var ud = fd, ad = /\s/, sd = /(_|-|\.|:)/, cd = /([a-z][A-Z]|[A-Z][a-z])/;
function fd(r) {
  return ad.test(r) ? r.toLowerCase() : sd.test(r) ? (pd(r) || r).toLowerCase() : cd.test(r) ? dd(r).toLowerCase() : r.toLowerCase();
}
var ld = /[\W_]+(.|$)/g;
function pd(r) {
  return r.replace(ld, function(t, n) {
    return n ? " " + n : "";
  });
}
var hd = /(.)([A-Z]+)/g;
function dd(r) {
  return r.replace(hd, function(t, n, e) {
    return n + " " + e.toLowerCase().split("").join(" ");
  });
}
var vd = ud, yd = gd;
function gd(r) {
  return vd(r).replace(/[\W_]+(.|$)/g, function(t, n) {
    return n ? " " + n : "";
  }).trim();
}
var md = yd, wd = $d;
function $d(r) {
  return md(r).replace(/\s(\w)/g, function(t, n) {
    return n.toUpperCase();
  });
}
const hr = /* @__PURE__ */ Fn(wd);
var an = "/";
const Le = function(r) {
  return r.indexOf(an) === -1 ? hr(r) : r.split(an).map(hr).join(an);
}, gn = function(r, t) {
  return r.reduce(function(n, e) {
    return t(n, e);
  }, {});
}, Jt = function(r) {
  return typeof Map < "u" && r instanceof Map;
};
function Kn(r) {
  if (Jt(r))
    return Array.from(r.keys());
  if (typeof Reflect < "u" && typeof Reflect.ownKeys == "function")
    return Reflect.ownKeys(r);
  var t = Object.getOwnPropertyNames(r);
  return typeof Object.getOwnPropertySymbols == "function" && (t = t.concat(Object.getOwnPropertySymbols(r))), t;
}
function Ne(r, t) {
  return Jt(t) ? t.get(r) : t[r];
}
const Te = function(r) {
  return function t(n, e, i, o) {
    var u = e === void 0 ? {} : e, a = u.namespace, c = a === void 0 ? Xn : a, f = u.prefix;
    i === void 0 && (i = {}), o === void 0 && (o = "");
    function l(g) {
      var b;
      if (!o)
        return g;
      var E = g.toString().split(mt), O = o.split(mt);
      return (b = []).concat.apply(b, O.map(function(Pt) {
        return E.map(function(ri) {
          return "" + Pt + c + ri;
        });
      })).join(mt);
    }
    function d(g) {
      return o || !f || f && new RegExp("^" + f + c).test(g) ? g : "" + f + c + g;
    }
    return Kn(n).forEach(function(g) {
      var b = d(l(g)), E = Ne(g, n);
      r(E) ? t(E, {
        namespace: c,
        prefix: f
      }, i, b) : i[b] = E;
    }), i;
  };
}, Od = Te(ut);
function _d(r, t) {
  var n = t === void 0 ? {} : t, e = n.namespace, i = e === void 0 ? Xn : e, o = n.prefix;
  function u(c, f, l) {
    var d = Le(l.shift());
    Ce(l) ? f[d] = r[c] : (f[d] || (f[d] = {}), u(c, f[d], l));
  }
  var a = {};
  return Object.getOwnPropertyNames(r).forEach(function(c) {
    var f = o ? c.replace("" + o + i, "") : c;
    return u(c, a, f.split(i));
  }), a;
}
function Tt(r) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {}, e = Object.keys(n);
    typeof Object.getOwnPropertySymbols == "function" && (e = e.concat(Object.getOwnPropertySymbols(n).filter(function(i) {
      return Object.getOwnPropertyDescriptor(n, i).enumerable;
    }))), e.forEach(function(i) {
      Ad(r, i, n[i]);
    });
  }
  return r;
}
function Ad(r, t, n) {
  return t in r ? Object.defineProperty(r, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : r[t] = n, r;
}
function xd(r) {
  for (var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), e = 1; e < t; e++)
    n[e - 1] = arguments[e];
  var i = ut(od(n)) ? n.pop() : {};
  return J(n.every(Rt) && (Rt(r) || ut(r)), "Expected optional object followed by string action types"), Rt(r) ? dr([r].concat(n), i) : Tt({}, Id(r, i), dr(n, i));
}
function Id(r, t) {
  var n = Od(r, t), e = ke(n);
  return _d(e, t);
}
function ke(r, t) {
  var n = t === void 0 ? {} : t, e = n.prefix, i = n.namespace, o = i === void 0 ? Xn : i;
  function u(a) {
    if (U(a) || Re(a))
      return !0;
    if (pr(a)) {
      var c = a[0], f = c === void 0 ? V : c, l = a[1];
      return U(f) && U(l);
    }
    return !1;
  }
  return gn(Object.keys(r), function(a, c) {
    var f, l = r[c];
    J(u(l), "Expected function, undefined, null, or array with payload and meta " + ("functions for " + c));
    var d = e ? "" + e + o + c : c, g = pr(l) ? Nt.apply(void 0, [d].concat(l)) : Nt(d, l);
    return Tt({}, a, (f = {}, f[c] = g, f));
  });
}
function dr(r, t) {
  var n = gn(r, function(i, o) {
    var u;
    return Tt({}, i, (u = {}, u[o] = V, u));
  }), e = ke(n, t);
  return gn(Object.keys(e), function(i, o) {
    var u;
    return Tt({}, i, (u = {}, u[Le(o)] = e[o], u));
  });
}
var Sd = bd;
function bd(r, t) {
  return function n() {
    t == null && (t = r.length);
    var e = [].slice.call(arguments);
    return e.length >= t ? r.apply(this, e) : function() {
      return n.apply(this, e.concat([].slice.call(arguments)));
    };
  };
}
const Ed = /* @__PURE__ */ Fn(Sd), jd = function(r, t) {
  return Ed(Nt(r, t), t.length);
}, Wd = function(r) {
  return r === void 0;
};
function Me(r, t, n) {
  t === void 0 && (t = V);
  var e = yn(r).split(mt);
  J(!Wd(n), "defaultState for reducer handling " + e.join(", ") + " should be defined"), J(U(t) || ut(t), "Expected reducer to be a function or object with next and throw reducers");
  var i = U(t) ? [t, t] : [t.next, t.throw].map(function(a) {
    return Re(a) ? V : a;
  }), o = i[0], u = i[1];
  return function(a, c) {
    a === void 0 && (a = n);
    var f = c.type;
    return !f || e.indexOf(yn(f)) === -1 ? a : (c.error === !0 ? u : o)(a, c);
  };
}
const Bd = function() {
  for (var r = arguments.length, t = Array(r), n = 0; n < r; n++)
    t[n] = arguments[n];
  var e = typeof t[t.length - 1] != "function" && t.pop(), i = t;
  if (typeof e > "u")
    throw new TypeError("The initial state may not be undefined. If you do not want to set a value for this reducer, you can use null instead of undefined.");
  return function(o, u) {
    for (var a = arguments.length, c = Array(a > 2 ? a - 2 : 0), f = 2; f < a; f++)
      c[f - 2] = arguments[f];
    var l = typeof o > "u", d = typeof u > "u";
    return l && d && e ? e : i.reduce(function(g, b) {
      return b.apply(void 0, [g, u].concat(c));
    }, l && !d && e ? e : o);
  };
};
function Dd(r) {
  var t = Kn(r), n = t.every(function(e) {
    return e === "next" || e === "throw";
  });
  return t.length && t.length <= 2 && n;
}
const Pd = Te(function(r) {
  return (ut(r) || Jt(r)) && !Dd(r);
});
function Cd(r, t, n) {
  n === void 0 && (n = {}), J(ut(r) || Jt(r), "Expected handlers to be a plain object.");
  var e = Pd(r, n), i = Kn(e).map(function(u) {
    return Me(u, Ne(u, e), t);
  }), o = Bd.apply(void 0, i.concat([t]));
  return function(u, a) {
    return u === void 0 && (u = t), o(u, a);
  };
}
const Rd = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  combineActions: id,
  createAction: Nt,
  createActions: xd,
  createCurriedAction: jd,
  handleAction: Me,
  handleActions: Cd
}, Symbol.toStringTag, { value: "Module" })), Ld = /* @__PURE__ */ De(Rd);
var qe = {};
const Nd = /* @__PURE__ */ De(Zp);
(function(r) {
  var t = Q && Q.__createBinding || (Object.create ? function(u, a, c, f) {
    f === void 0 && (f = c);
    var l = Object.getOwnPropertyDescriptor(a, c);
    (!l || ("get" in l ? !a.__esModule : l.writable || l.configurable)) && (l = { enumerable: !0, get: function() {
      return a[c];
    } }), Object.defineProperty(u, f, l);
  } : function(u, a, c, f) {
    f === void 0 && (f = c), u[f] = a[c];
  }), n = Q && Q.__setModuleDefault || (Object.create ? function(u, a) {
    Object.defineProperty(u, "default", { enumerable: !0, value: a });
  } : function(u, a) {
    u.default = a;
  }), e = Q && Q.__importStar || function(u) {
    if (u && u.__esModule)
      return u;
    var a = {};
    if (u != null)
      for (var c in u)
        c !== "default" && Object.prototype.hasOwnProperty.call(u, c) && t(a, u, c);
    return n(a, u), a;
  };
  Object.defineProperty(r, "__esModule", { value: !0 }), r.toClients = r.toUsers = r.toChats = r.mergeToMeta = r.convertFromObjToId = r.removeSendInfoFromMeta = r.payload = void 0;
  const i = e(Nd);
  r.payload = i.filter((u) => u !== void 0), r.removeSendInfoFromMeta = i.evolve({
    meta: i.omit([
      "from",
      "to",
      "context",
      "service",
      "socketType",
      "socketId",
      "token"
    ])
  }), r.convertFromObjToId = i.evolve({
    payload: {
      from: i.prop("userId")
    }
  });
  const o = (u, a) => ({
    ...u,
    meta: { ...u.meta, ...a }
  });
  r.mergeToMeta = o, r.toChats = i.curry((u, a, c) => {
    const f = i.isEmpty(c) ? ["chats", u] : ["chats", u, c.users || [], c.clients || []];
    return (0, r.mergeToMeta)(a, { to: f });
  }), r.toUsers = i.curry((u, a, c) => {
    const f = i.isEmpty(c) ? ["users", u] : ["users", u, c];
    return (0, r.mergeToMeta)(a, { to: f });
  }), r.toClients = i.curry((u, a) => (0, r.mergeToMeta)(a, { to: ["clients", u] }));
})(qe);
(function(r) {
  Object.defineProperty(r, "__esModule", { value: !0 }), r.dataCommonGetByIds = r.DATA_COMMON_GET_BY_IDS = r.dataCommonGetById = r.DATA_COMMON_GET_BY_ID = void 0;
  const t = Ld, n = qe, e = (i, o) => o && { dest: o };
  r.DATA_COMMON_GET_BY_ID = "DATA_COMMON_GET_BY_ID", r.dataCommonGetById = (0, t.createAction)(r.DATA_COMMON_GET_BY_ID, ({ id: i, doc: o }) => (0, n.payload)({
    id: i,
    doc: o
  }), e), r.DATA_COMMON_GET_BY_IDS = "DATA_COMMON_GET_BY_IDS", r.dataCommonGetByIds = (0, t.createAction)(r.DATA_COMMON_GET_BY_IDS, ({ ids: i, docs: o }) => (0, n.payload)({
    ids: i,
    docs: o
  }), e);
})(Pe);
const v = {}, Td = (r, t, { req: n, hooks: e } = {}) => {
  const i = st("path", t);
  v.getState = (o) => ce([], i[o], r.getState()), v.req = n, v.oldReqByIds = async (o, u) => {
    const { dest: a } = t[o];
    if (!a)
      return [];
    const c = await n(Pe.dataCommonGetByIds({ ids: u }, a)), f = F(["payload", "docs"], c);
    return v.getHook("beforeInsert", o)(f);
  }, v.reqByIds = (o, u) => v.getUpdateOptions(o) ? v.getUpdates(o, u) : v.oldReqByIds(o, u), v.getUpdateOptions = (o) => t[o].updateOptions, v.getUpdates = async (o, u) => {
    const { updateOptions: a } = t[o];
    if (!a || !u.length)
      return [];
    const { updateKey: c = "updatedAt", request: f } = a, l = v.getKey(o), d = {};
    if (Ot(Object, u[0]))
      for (const b of u)
        d[b[l]] = b[c];
    else
      for (const b of u)
        d[b] = null;
    const g = await f(d);
    return v.getHook("beforeInsert", o)(g);
  }, v.getHook = (o, u) => {
    const a = F([u, o], e);
    return typeof a == "function" ? a : Et;
  }, v.getKey = (o) => t[o].reduxKey || "id";
}, Bt = (r) => (t) => [r, ...t].join("_").toUpperCase(), Ht = Bt("change"), Ue = Bt("upinsert"), zn = Bt("insert"), Gn = Bt("update"), Zt = Bt("remove"), dt = {}, gt = (r) => (t) => ({ type: r, payload: t }), kd = (r, t) => {
  j(t).forEach((n) => {
    const { path: e } = t[n], i = {
      change: gt(Ht(e)),
      insert: gt(zn(e)),
      upInsert: gt(Ue(e)),
      update: gt(Gn(e)),
      remove: gt(Zt(e))
    };
    dt[n] = S(
      (o) => (u) => r.dispatch(o(u)),
      i
    );
  });
}, Md = (r, t, n) => {
  Td(r, t, n), kd(r, t);
}, Sv = (r) => v.getState(r), bv = (r, t) => v.getState(r).filter(ht(t)), Qt = (r, t) => dt[r].change(t), _t = (r, t) => dt[r].insert(t), Ev = (r, t) => dt[r].upInsert(t), Fe = (r, t, n) => dt[r].update({ findObj: t, data: n }), Vn = (r, t) => dt[r].remove({ findObj: t }), tn = (r) => {
  try {
    return JSON.parse(window.localStorage.getItem(r));
  } catch (t) {
    return console.warn("Can't query localStorage:", t), null;
  }
}, Xe = (r, t) => {
  try {
    return window.localStorage.setItem(r, JSON.stringify(t)), t;
  } catch (n) {
    return console.warn("Can't update localStorage:", n), null;
  }
}, qd = (r, t, n) => {
  const e = tn(r);
  return typeof e != "object" ? null : Xe(r, xt(t, n, e));
}, Ud = (r) => {
  const t = tn(r);
  return window.localStorage.removeItem(r), t;
}, jv = () => window.localStorage.clear(), Fd = (r) => {
  const t = tn(r);
  t != null && Qt(r, t);
}, Wv = (r) => tn(r), Bv = (r, t) => {
  const n = Xe(r, t);
  return Qt(r, n), n;
}, Dv = (r, t, n) => {
  const e = qd(r, t, n);
  return e != null && Qt(r, e), e;
}, Pv = (r) => {
  const t = Ud(r);
  return Vn(r), t;
}, Xd = (r, t) => {
  const n = Object.keys(r);
  return Promise.all(n.map((e) => nv(e))).then((e) => {
    e.forEach((i, o) => Qt(n[o], i)), t();
  });
}, Kd = (r, t = () => {
}) => {
  Object.keys(r).forEach((n) => {
    r[n].autoRehydrate && r[n].layer === "local" && Fd(n);
  }), t();
}, zd = (r, t) => Object.keys(t).reduce(
  (n, e) => xt(e.split("."), t[e], n),
  r
), Gd = (r, t) => Object.keys(t).reduce(
  (n, e) => Pn(e.split("."), n),
  r
), Vd = (r, t) => Object.keys(t).reduce(
  (n, e) => ({ ...n, [e]: r[e] + t[e] }),
  r
), Yd = (r, t) => Object.keys(t).reduce(
  (n, e) => ({ ...n, [e]: Math.max(t[e], r[e]) }),
  r
), Jd = (r, t) => {
  const n = Object.keys(t)[0], e = t[n];
  return It(n, r[n].concat(e.$each || e), r);
}, Hd = (r, t) => {
  const n = Object.keys(t)[0], e = t[n];
  return It(n, Lt(r[n], e), r);
}, Ke = {
  $set: zd,
  $unset: Gd,
  $inc: Vd,
  $max: Yd,
  $push: Jd,
  $pullAll: Hd
}, ze = Sn(An, _r(we("$")), j), Yn = (r, t) => ze(t) ? t : Object.keys(t).reduce((n, e) => {
  const i = Ke[e];
  return i ? i(n, t[e]) : n;
}, r), Zd = async () => navigator.storage && navigator.storage.persist ? await navigator.storage.persisted() || navigator.storage.persist() : (console.log("Persistent storage is not available."), !1), Qd = (r = 1e3) => new Promise((t) => setTimeout(t, r)), Dt = "readwrite";
let Ge;
const C = new Promise((r) => {
  Ge = r;
}), tv = async (r, t, n, e, i = !0, o = () => {
}, u = () => {
}) => {
  await Promise.race([Zd(), Qd(20)]);
  const a = await ah(r, t, {
    blocked() {
      console.log("idb open blocked");
    },
    blocking() {
      console.log("idb version change", a), a.close();
    },
    terminated() {
      console.log("idb terminated");
    },
    ...n
  });
  Ge(a), i && (await u(), Xd(
    ct(
      _n(ve("layer", "db"), q("autoRehydrate")),
      e
    ),
    o
  ));
}, Ve = async (r, t, { index: n, keyOnly: e, count: i, direction: o } = {}) => {
  try {
    const u = n ? r.index(n) : r;
    if (!o) {
      if (e) {
        if (typeof u.getAllKeys < "u")
          return u.getAllKeys(t, i);
      } else if (typeof u.getAll < "u")
        return u.getAll(t, i);
    }
    const a = e ? "primaryKey" : "value", c = e && typeof u.openKeyCursor < "u" ? "openKeyCursor" : "openCursor", f = [];
    let l = await u[c](t, o);
    for (; l && (f.push(l[a]), !(i && f.length === i)); )
      l = await l.continue();
    return f;
  } catch (u) {
    return console.error(
      `DBGetAllFromStore: Can't get from store=${r}, index=${n}`,
      u
    ), [];
  }
}, nv = (r, t, n) => C.then(
  (e) => Ve(e.transaction(r).store, t, n)
), Cv = (r, t, n) => C.then(
  (e) => n ? e.getFromIndex(r, n, t) : e.get(r, t)
);
async function Rv(r, t, n) {
  let i = await (await C).transaction(r).store.index(n).openCursor(), o = t.toUpperCase(), u = t.toLowerCase(), a = o;
  if (!i)
    return;
  for (; i; ) {
    const f = i.key, l = i.value;
    if (typeof f != "string")
      continue;
    const d = f.toLowerCase();
    if (d === u)
      return l;
    if (a = c(f, d, o, u), a && (i = await i.continue(a), i))
      continue;
    return;
  }
  function c(f, l, d, g) {
    const b = Math.min(f.length, g.length);
    let E = -1;
    for (let O = 0; O < b; ++O) {
      const Pt = l[O];
      return Pt !== g[O] ? f[O] < d[O] ? f.substring(0, O) + d[O] + d.substring(O + 1) : f[O] < g[O] ? f.substring(0, O) + g[O] + d.substring(O + 1) : E >= 0 ? f.substring(0, E) + l[E] + d.substring(E + 1) : void 0 : (f[O] < Pt && (E = O), b < g.length ? f + d.substring(f.length) : E < 0 ? void 0 : f.substring(0, E) + g[E] + d.substring(E + 1));
    }
  }
}
const rv = (r, t) => C.then((n) => {
  const e = n.transaction(r), { store: i } = e;
  return Promise.all(S((o) => i.get(o), t)).then(
    ct(Boolean)
  );
}), nn = (r, t) => C.then((n) => {
  if (!Array.isArray(t))
    return n.put(r, t);
  if (!t.length)
    return null;
  const e = n.transaction(r, Dt), { store: i } = e;
  return k((o) => i.put(o), t), e.done;
}), ev = (r, t, n, e = !1) => C.then(async (i) => {
  const o = i.transaction(r, Dt), { store: u } = o, a = await u.get(t);
  return (a || e) && u.put(Yn(a || {}, n)), o.done;
}), Lv = (r, t, n, e) => C.then(async (i) => {
  const o = i.transaction(r, Dt), { store: u } = o, a = e ? u.index(e) : u;
  return k(async (c) => {
    let f = await a.openCursor(c);
    for (; f; )
      f.update(Yn(f.value, n)), f = await f.continue();
  }, t), o.done;
}), iv = (r, t, n) => C.then(async (e) => {
  const i = ht(t), o = e.transaction(r, Dt), { store: u } = o;
  let a = await u.openCursor();
  for (; a; )
    i(a.value) && a.update(Yn(a.value, n)), a = await a.continue();
  return o.done;
}), ov = (r, t) => C.then((n) => n.delete(r, t)), uv = (r, t, n) => Promise.all(
  S(
    (e) => Ve(r, e, { index: n, keyOnly: !0 }),
    t
  )
).then(Kr), av = (r, t, n) => C.then(async (e) => {
  const i = e.transaction(r, Dt), { store: o } = i, u = n ? await uv(o, t, n) : t;
  return k((a) => o.delete(a), u), i.done;
}), Nv = (r) => C.then((t) => t.clear(r)), Tv = sh, sv = /* @__PURE__ */ (() => {
  const r = {};
  return (t) => {
    const n = v.getState(t);
    if (r[t] && r[t].state === n)
      return r[t].values;
    const e = Object.values(n);
    return r[t] = { state: n, values: e }, e;
  };
})(), kv = (r, t) => sv(r).filter(ht(t)), Ye = (r, t) => v.getState(r)[t], Mv = (r, t) => fe(t, v.getState(r)), cv = (r) => ({
  [Ht(r)]: (t, n) => n,
  [Zt(r)]: () => null
}), fv = (r) => (t = {}, { type: n, payload: e }) => r[n] ? r[n](t, e) : t, qv = (r) => fv(cv(r)), Je = (r, { findObj: t, data: n }) => {
  const e = ht(t);
  return ze(n) ? S((i) => e(i) ? n : i, r) : Object.keys(n).reduce((i, o) => {
    const u = Ke[o];
    return u ? S((a) => e(a) ? u(a, n[o]) : a, i) : i;
  }, r);
}, lv = (r, t) => t, pv = (r, t) => r.concat(t), hv = (r, t) => [...t, ...r], dv = (r, { findObj: t }) => {
  const n = r.filter(jr(ht(t)));
  return n.length === r.length ? r : n;
}, vv = (r) => ({
  [Ht(r)]: lv,
  [zn(r)]: pv,
  [Ue(r)]: hv,
  [Gn(r)]: Je,
  [Zt(r)]: dv
}), yv = (r) => (t = [], { type: n, payload: e }) => r[n] ? r[n](t, e) : t, Uv = (r) => yv(vv(r)), He = (r, t) => L(
  (n, e) => (n[e[t]] = e, n),
  {},
  r
), gv = (r, t) => {
  const n = v.getKey(t);
  if (!r[n] || Object.keys(r).length !== 1)
    return !1;
  const e = r[n];
  return $t(e) !== "Object" ? [e] : e.$in && Object.keys(e).length === 1 ? e.$in : !1;
}, mv = (r) => (t, n) => Array.isArray(n) ? He(n, v.getKey(r)) : n, wv = (r) => (t, n) => ({
  ...t,
  ...He(Array.isArray(n) ? n : [n], v.getKey(r))
}), $v = (r) => (t, { findObj: n }) => {
  if (n == null)
    return t;
  if (Object.keys(n).length === 0)
    return {};
  const e = gv(n, r);
  return e ? ie(e, t) : ft(ht(n), t);
}, Ov = (r) => {
  const t = Rn(r);
  return {
    [Ht(r)]: mv(t),
    [zn(r)]: wv(t),
    // N.A.
    // [upInsertActionType(path)]: (state, payload) => [...payload, ...state],
    // TODO: improve by utilizing `getNormSupportedKeys`
    [Gn(r)]: Je,
    [Zt(r)]: $v(t)
  };
}, _v = (r) => (t = {}, { type: n, payload: e }) => r[n] ? r[n](t, e) : t, Fv = (r) => _v(Ov(r)), X = {}, Av = async (r, t) => {
  var c;
  if (!v.getUpdateOptions(r))
    return;
  const n = v.getKey(r), e = (c = X[r]) == null ? void 0 : c.forceKeepSet, i = e != null && e.size ? ft((f) => {
    if (e.has(f[n]))
      return e.delete(f[n]), !0;
  }, t) : t, [o, u] = Qe(r, i), a = await v.getUpdates(r, o);
  u(), a.length && (_t(r, a), nn(r, a));
}, Ze = async (r, t) => {
  var a;
  if (!v.getUpdateOptions(r))
    return;
  const n = v.getKey(r), e = (a = X[r]) == null ? void 0 : a.forceUpdateSet;
  if (!(e != null && e.has(t[n])))
    return;
  e.delete(t[n]);
  const [i, o] = Qe(r, [t]), u = await v.getUpdates(r, i);
  o(), u.length && (_t(r, u), nn(r, u));
}, Jn = (r) => {
  X[r] || (X[r] = {
    forceUpdateSet: /* @__PURE__ */ new Set(),
    forceKeepSet: /* @__PURE__ */ new Set(),
    updatingSet: /* @__PURE__ */ new Set()
  });
}, Xv = (r, t) => {
  Jn(r), k((n) => {
    X[r].forceUpdateSet.add(n), X[r].forceKeepSet.delete(n);
  }, t);
}, Kv = (r, t) => {
  Jn(r), k((n) => X[r].forceKeepSet.add(n), t);
};
function Qe(r, t) {
  Jn(r);
  const n = v.getKey(r), { updatingSet: e } = X[r], i = t.filter((u) => !e.has(u[n]));
  return i.forEach((u) => e.add(u[n])), [i, () => i.forEach((u) => e.delete(u[n]))];
}
typeof window.queueMicrotask != "function" && (window.queueMicrotask = function(t) {
  Promise.resolve().then(t).catch(
    (n) => setTimeout(() => {
      throw n;
    })
  );
});
const vr = (r, t, n) => {
  const e = v.getKey(r);
  k((i) => {
    const o = i[e];
    k((u) => u(i), t[o]), delete t[o];
  }, n);
}, xv = async (r, t) => {
  const n = await rv(r, Object.keys(t));
  n.length && (_t(r, n), vr(r, t, n), Av(r, n));
  const e = Object.keys(t);
  if (!e.length)
    return "idb";
  const i = await v.reqByIds(r, e);
  i.length && (_t(r, i), vr(r, t, i), nn(r, i)), Ln(
    k((o) => o(null)),
    t
  );
};
let z = {}, mn = !1;
const Iv = () => {
  Ln(async (r, t) => {
    try {
      await xv(t, r);
    } catch (n) {
      console.log("persist.getAndCacheCollection", t, r, n);
    }
  }, z), z = {}, mn = !1;
}, ti = (r, t, n) => (z[r] ? z[r][t] || (z[r][t] = []) : z[r] = { [t]: [] }, mn || (window.queueMicrotask(Iv), mn = !0), n ? null : new Promise((e) => z[r][t].push(e))), zv = (r) => (t) => (_t(r, t), nn(r, t)), Gv = (r) => (t, n) => (Fe(r, t, n), iv(r, t, n)), Vv = (r) => (t, n) => (Fe(r, { [v.getKey(r)]: t }, n), ev(r, t, n)), Yv = (r) => (t) => (Vn(r, { [v.getKey(r)]: t }), ov(r, t)), Jv = (r) => (t) => (Vn(r, { [v.getKey(r)]: { $in: t } }), av(r, t)), ni = _n(Boolean, Ur(Ot(String), Ot(Number))), Hv = jt((r, t) => {
  if (!ni(t))
    return null;
  const n = Ye(r, t);
  return n ? (Ze(r, n), n) : (ti(r, t, !0), null);
}), Zv = jt(async (r, t) => {
  if (!ni(t))
    return null;
  const n = Ye(r, t);
  return n ? (Ze(r, n), n) : ti(r, t);
}), Qv = (r, t, n, e, i, o = {}) => {
  try {
    i && Md(i, ct(q("path"), e), o), tv(
      r,
      t,
      n,
      e,
      !0,
      o.afterReduxRehydrate,
      o.beforeReduxRehydrate
    ), Kd(e, o.afterLocalRehydrate);
  } catch (u) {
    console.warn("persist error:", u);
  }
};
export {
  Nv as DBClear,
  Tv as DBDrop,
  nv as DBFind,
  rv as DBFindMany,
  Cv as DBFindOne,
  Rv as DBFindOneCaseInsensitive,
  tv as DBInitiation,
  nn as DBInsert,
  ov as DBRemove,
  av as DBRemoveMany,
  Lv as DBUpdateMany,
  ev as DBUpdateOne,
  jv as LocalClear,
  tn as LocalFind,
  Xe as LocalInsert,
  Ud as LocalRemove,
  qd as LocalUpdate,
  Qt as ReduxChange,
  bv as ReduxFind,
  Sv as ReduxFindAll,
  sv as ReduxFindAllNorm,
  Ye as ReduxFindByIdNorm,
  Mv as ReduxFindByIdsNorm,
  kv as ReduxFindNorm,
  _t as ReduxInsert,
  Vn as ReduxRemove,
  Ev as ReduxUpInsert,
  Fe as ReduxUpdate,
  C as dbPromise,
  Uv as dbReducer,
  vv as dbReducerFuncCreator,
  Fv as dbReducerNorm,
  Ov as dbReducerNormFuncCreator,
  Qv as default,
  Hv as findById,
  Zv as findByIdAsync,
  Kv as forceKeep,
  Xv as forceUpdate,
  zv as insert,
  qv as localReducer,
  cv as localReducerFuncCreator,
  Wv as localReduxFind,
  Bv as localReduxInsert,
  Pv as localReduxRemove,
  Dv as localReduxUpdate,
  Jv as removeMany,
  Yv as removeOne,
  Gv as update,
  Vv as updateOne
};
//# sourceMappingURL=weblite-persist.js.map
